import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    OnChanges,
    Input,
    ViewChild,
    ElementRef,
    ViewChildren, AfterViewInit, QueryList
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GlobalsService } from '../../services/globals.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { SendDataService } from './services/send-data.sevice';
import { DataVehiculosService } from '../../../dms/modulos/general/componentes/gestion-vehiculos/services/data-vehiculos.service';
import { Subscription ,  Observable } from 'rxjs';
import { GestionTercerosService } from '../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import { environment } from '../../../../environments/environment';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';
import { OPB } from '../../interfaces/opb';
import { InformationBoxService } from '../InformationBox/information-box.service';
import { TranslateService } from '@ngx-translate/core';
import { VehicleBrand } from '../../interfaces/vehicleBrand';
import { GestionService } from '../../../dms/modulos/taller/componentes/gestion-or/gestion.service';
import { AuthService } from '../../services/auth.service';
import { Vendor } from '../../interfaces/vendor';
import { DataSaveService } from '../../services/data-save.service';
import { GestionVehiculosService } from '../../../dms/modulos/general/componentes/gestion-vehiculos/gestion-vehiculos.service';
import {map, take} from 'rxjs/operators';
import { VehicleValuationDetailList } from '../../interfaces/detailsEvaluationCar';
import { Router } from '@angular/router';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Child } from '../../interfaces/child.interface';
import { Paginacion } from '../../interfaces/paginacion';
import { RedirectService } from '../../services/redirect.service';
import { RecepcionVehiculoStepsService } from '../../../dms/modulos/taller/componentes/recepcion-vehiculo/recepcion-vehiculo-steps.service';
import { Carroceria } from '../../constans/carroceria';
import { RecepcionVoService } from '../../../dms/modulos/vc-vo/componentes/recepcion-vo/recepcion-vo.service';
import { AdjuntarDocumentosVehiculoService } from '../../../shared/components/adjuntar-documentos-vehiculo/adjuntar-documentos-vehiculo.service';
import {modelYearValidator} from '../../validators/modelYear.validator';
import { ORCustomerVehicleService } from '../../services/or-customer-vehicle.service';
import {ButtonsActivateService} from '../../services/buttons-activate.service';
declare let $: any;


@Component({
    selector: 'dms-gestion-form',
    templateUrl: './gestion-form.component.html',
    styleUrls: ['./gestion-form.component.scss']
})
@AutoUnsubscribe()
export class GestionFormComponent implements OnInit, OnChanges, AfterViewInit {
    public defaultItem: { Description: string, Value: number };
    opbCode: string;
    opbDescription: string;
    desactivarGestExp: boolean;
    RowData: any;
    vehicleStates: any[] = [];
    ubicaciones: any[] = [];
    error: string;
    code: string;
    filial: string;
    VehicleBrand: VehicleBrand;
    BrandCode: string;
    GuaranteeExtCode: object;
    GuaranteeCode: string;
    CustomerId: string;
    vehiculoForm: FormGroup;
    CLIENTCODE: string;
    COMPANYCODE: string;
    gestion: FormGroup;
    carroceria: FormGroup;
    caractVehic: FormGroup;
    compraVehic: FormGroup;
    unamePattern: string;
    ownerChangeString: string;
    isLoadingGestion = false;
    rowCode: number;
    botonNuevo = true;
    edit = true;
    remove = true;
    segurityCode: any;
    codigosGarantia: any[];
    CustomerCodePhone: string;
    mostrarLupas: boolean;
    ordenSeleccionada: any;
    public registrationDate: string;
    DDCEnabled: boolean = false;
    longitudKO = false;
    anioKO = false ;
    fisrtYear = 1886 ;
    currentYear: any;

    vehicleEngine: any = [];
    comboCarroceria: any[] = [];
    ordenesAbiCurCerr: any[] = [];
    hayOrdenesAbiertas: boolean;
    dataOpb: any;
    tipoSearch: string;
    tipo: string;
    stateVehicle: any[];
    lastRepair: any;
    userProfile: any;
    statusFormSend: string;
    ordenStatus: string;
    informationBox = true;
    boxSearch = false;
    newOwnerData: object;
    textoBoxForm: string;
    informationClientSearch: any[] = [];
    dataCustomer: any;
    paisService: string;
    fechaActual: any;
    CustomerName: string;
    CustomerCode: string;
    ThirdPartyCustomerCode: string;
    ThirdPartyDriverCodeDriverCode: string;
    ThirdPartyInvoiceCodeCustomerInvoiceCode: string;
    FiscalCode: string;
    TelephonePortable: string;
    TelephoneHome: string;
    deshabilitarCampos: boolean;
    ThirdParty: any;
    ThirdPartyDriverCode: any;
    ThirdPartyInvoiceCode: any;
    CustomerPrescriber: any;
    CustomerKeeper: any;
    customResult: any;
    PlateNumber: string;
    citas: any[] = [];
    gridView: GridDataResult;
    Vin: string;
    internalUse: string;
    allDataCustomer: Subscription;
    vehicleValuationDetailList: VehicleValuationDetailList[] = [];
    public formatOptions: any = {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol'
    };
    public min = 0;
    public max = 10000;
    modoEdicion: boolean;
    email: string;
    emailPara: string;

    formularioGuardado: any;
    formularioGestion: any;
    formularioCarroceria: any;
    formularioCaractVehic: any;
    formularioCompraVehic: any;

    isNew: boolean;
    datosVendedores: Vendor[] = [];
    @Input() formMode?: boolean;
    @Input() transmitter: string;
    @Input() tab?: number;
    @Input() codeOfCustomer?: any;
    @Input() isModal: boolean = false;

    @Output() cancel = new EventEmitter<boolean>();
    @Output() anterior = new EventEmitter();

    @Output() onDataRegister = new EventEmitter<any>();

    @ViewChildren('codigo') inputCodeQuery: QueryList<ElementRef>;  // no reactive
    public inputCode: ElementRef;
    @ViewChild('codigoDescription', { static: false }) textACode: ElementRef; // no reactive

    @ViewChild('customercode', { static: false }) customercode: ElementRef;
    @ViewChild('customername', { static: false }) customername: ElementRef;

    @ViewChild('customercodedriver', { static: false }) customercodedriver: ElementRef;
    @ViewChild('customernamedriver', { static: false }) customernamedriver: ElementRef;

    @ViewChild('customercodeinvoice', { static: false }) customercodeinvoice: ElementRef;
    @ViewChild('customernameinvoice', { static: false }) customernameinvoice: ElementRef;

    @ViewChild('customerCodePrescriberCode', { static: false }) customerCodePrescriberCode: ElementRef;
    @ViewChild('customerNamePrescriberCode', { static: false }) customerNamePrescriberCode: ElementRef;

    @ViewChild('customerKeeperCode', { static: false }) customerKeeperCode: ElementRef;
    @ViewChild('customerKeeperName', { static: false }) customerKeeperName: ElementRef;
    url_ChassisWithCarCodes: string;
    placeholderPlateNumber: string;
    placeholderVin: string;
    placeholderDescripcion: string;
    placeholderModelYear: string;
    placeholderCustomerCode: string;
    placeholderCustomerName: string;
    placeholdercustomercodedriver: string;
    placeholdercustomernamedriver: string;
    placeholdercustomercodeinvoice: string;
    placeholdercustomernameinvoice: string;
    primerCampo: object;
    primerCampoUbi: object;
    textObligado: string;
    selectedAccount: any;
    segurity: any[] = [{
        title: '',
        th: ['labels.codigo', 'labels.descripcion'],
        fields: ['VEHICLECODE', 'Value'],
        width: ['100', '150']
    }];
    loadingData: boolean;
    GetAllVehicles: any;
    customerCode: string;
    chassis: string;
    status: string;
    custumerData: any;
    carData: any;
    public minDate: Date;
    public maxDate: Date;
    customerFirst: boolean;
    aplicationType: any;
    activarLamparita: boolean;
    // ********** PANTALLAS*************//
    presupuestosTaller: boolean;
    gestionTerceros: boolean;
    gestionVehiculos: boolean;
    stockVO: boolean;
    gestionVehiculosCortesia: boolean;
    recepcionVehiculo: boolean;
    recepcionVO: boolean;
    gestionOr: boolean;
    // ********** PANTALLAS*************//
    bandDescription: string;
    matriculaOk: boolean;
    ModelYearOK: boolean;
    VinOk: boolean;
    matriculaDuplicate: boolean;
    VinDuplicate: boolean;

    formularioCargadoObserver: Subscription;
    getDatosTablaGestionForm: any;
    ShowDataVin = false;
    showModalPhone = false;
    showModalVehicle = false;
    showModalOrders = false;
    showModalVendors = false;
    vehicleState: string;
    moduloTaller: any;
    moduloGeneral: any;
    moduloVO: any;
    /******PESTAÑAS*******/
    showVehiculo: boolean;
    showPropietario: boolean;
    showGarantia: boolean;
    showOR: boolean;
    showSeguridad: boolean;
    showGestion: boolean;
    showEstadoCarroceria: boolean;
    showCitas: boolean;
    seleccionar: string;
    pais: string;
    trasera: string;
    maletero: string;
    rtraseraIzq: string;
    rTraseraDch: string;
    aletaTrasIzq: string;
    aletaTrasDch: string;
    lunaTrasera: string;
    puertaTrasIzq: string;
    puertatrasDer: string;
    faldonIzq: string;
    faldonDer: string;
    puertaDelIzq: string;
    puertaDelDer: string;
    techo: string;
    ruedaDelIzq: string;
    ruedaDelDer: string;
    lunaDelantera: string;
    correcto: string;
    defectuoso: string;
    capo: string;
    frontal: string;
    aletaDelIzq: string;
    aletaDelDer: string;
    child: Child;
    childs: Child[] = [];
    objetoPaginacion: Paginacion;
    creationDate: string;
    ID: number;
    vehicleValuationID: number;
    generic_title: string;
    generic_textButtonOk: string;
    generic_textButtonCancel: string;
    generic_aspa: boolean;
    generic_popupName = '';
    generic_message: string;
    generic_isButtonOk: boolean;
    generic_isButtonCancel: boolean;
    showModalGeneric = false;
    bajaVehiculo: string;
    siBaja = false;
    headerStyle = { 'background-color': '#f5f5f5' };
    public pageSize: number;
    public pageNumber: number;
    public skip: number;
    fechaActualFormated: string;
    bajaText: string;
    mediaFileList: any[];
    hasESA = false;
    showModalESA = false;

    private mediaFileSubscription: Subscription;
    private inputSubscription: Subscription;

    constructor(
        private _recepcionVehiculoStepsService: RecepcionVehiculoStepsService,
        private router: Router,
        private _gestionVehiculosService: GestionVehiculosService,
        private _authService: AuthService,
        private _gestionService: GestionService,
        private translateService: TranslateService,
        private _informationBoxService: InformationBoxService,
        private _gestionTercerosService: GestionTercerosService,
        private _dataVehiculosService: DataVehiculosService,
        private _sendData: SendDataService,
        private _globals: GlobalsService,
        private _dataSaveService: DataSaveService,
        private toastr: ToastrService,
        private _redirectService: RedirectService,
        private _adjuntarDocumentosService: AdjuntarDocumentosVehiculoService,
        private _ORCustomerVehicleService: ORCustomerVehicleService,
        private _buttonsActivateService: ButtonsActivateService
    ) {
        this.getVehicleEngine();
        this.opbCode = '';
        this.opbDescription = '';
        this.activarLamparita = false;
        this.gestionTerceros = false;
        this.currentYear = this._globals.getActualYear();

        this.bajaVehiculo = '';
        this.placeholderPlateNumber = '';
        this.placeholderVin = '';
        this.placeholderDescripcion = '';
        this.placeholderModelYear = '';
        this.placeholderCustomerCode = '';
        this.placeholderCustomerName = '';
        this.placeholdercustomercodedriver = '';
        this.placeholdercustomernamedriver = '';
        this.placeholdercustomercodeinvoice = '';
        this.placeholdercustomernameinvoice = '';
        this.botonNuevo = true;
        this.edit = true;
        this.remove = true;
        this.fechaActual = this._globals.getDateFormatToday();
        this.fechaActualFormated = this._globals.getDateFormatTodayDMY();
        this.paisService = this._authService.getDataPais();
        this.lastRepair = null;
        this.paginacionInicial();
    }

    ngOnInit() {
        if(this._dataSaveService.getCanEditVehicle() === true){
            this.isModal = false;
        }
        this.translateService.get('errors.required.campoObligatorio').subscribe(text => {
            this.textObligado = text;
        });
        this.translateService.get('gestion_terceros.identificationData.revocaDateText').subscribe(text => {
            this.bajaText = text;
            this.bajaVehiculo = this.bajaText + this.fechaActualFormated;
        });
        this.aplicationType = this._authService.getAplicationType();
        if (this.aplicationType && this.aplicationType.CompanyConfiguration) {
            // se ha sustituido por DDCEnabled
            this.customerFirst = this.aplicationType.CompanyConfiguration.CustomerFirstEnabled;
        }
        this.userProfile = this._authService.getDataContents();
        this.childs = this.userProfile.AppModules;
        this.moduloTaller = this.childs[3];
        this.moduloGeneral = this.childs[1];
        this.moduloVO = this.childs[7];
        this.pais = this._authService.getDataPais();
        if (!this.tab) {
            this.tab = 0;
        }
        if (this.tab === 1) {
            this.informationBox = false;
            this.boxSearch = true;
        } else {
            this.informationBox = true;
            this.boxSearch = false;
        }
        this.filial = this._authService.getFilial();
        this.vehicles();    // Servicio que devuelve las marcas
        this.getCodigos();      // Servicio que devuelve los cadigos de garantia para pestaña garantia
        this.cargarPantallas();
        this.cargarTextos();

        this._dataVehiculosService.observerCargadoFormulario().subscribe(val => {
            if (val === true) {
                this.comprobarPestana();
            }
        });

        this.mediaFileSubscription = this._adjuntarDocumentosService.getMediaFileList().subscribe(
            data => {
                this.mediaFileList = data;
            }
        );

        this.getDDCStatus();
    }

    getVehicleEngine(){
        this._sendData.getVehicleEngine().subscribe((data: any) => {
            this.vehicleEngine = data.Response.filter(engines => engines.Active === true);
        })
    }

    getDDCStatus(){
        const userProfile = this._authService.getAplicationType();
        if(userProfile && userProfile.hasOwnProperty('CompanyConfiguration') && userProfile.CompanyConfiguration.hasOwnProperty('DDCEnabled')){
            this.DDCEnabled = userProfile.CompanyConfiguration.DDCEnabled;
        }else{
            this.DDCEnabled = false;
        }
    }

    ngAfterViewInit(): void {
        // Al estar el elemento en un ngif tenemos que subscribir un observable y esperar a que el elemento exista
        this.inputSubscription = this.inputCodeQuery.changes.subscribe((componentes: QueryList<ElementRef>) => {
            this.inputCode = componentes.first;
        });
    }

    paginacionInicial() {
        this.skip = 0;
        this.pageNumber = 1;
        this.pageSize = 20;
        this.objetoPaginacion = {
            'skip': this.skip,
            'pageNumber': this.pageNumber,
            'pageSize': this.pageSize
        };
    }

    comprobarPestana() {
        const pestanaDatosVehiculoDescription = this.vehiculoForm.controls.Description.invalid;
        const pestanaDatosVehiculoModelYear = this.vehiculoForm.controls.ModelYear.invalid;
        if (pestanaDatosVehiculoDescription && pestanaDatosVehiculoModelYear) {
            $('#vehiculo').parent().parent().find('li.k-state-active').addClass('pestana_error');
        } else {
            $('#vehiculo').parent().parent().find('li.k-state-active').removeClass('pestana_error');
        }
        if (this.showPropietario) {
            const ThirdPartyC = this.vehiculoForm.controls.ThirdParty.get('CustomerCode').invalid;
            const ThirdPartyN = this.vehiculoForm.controls.ThirdParty.get('CustomerName').invalid;

            const ThirdPartyDriverCodeC = this.vehiculoForm.controls.ThirdPartyDriverCode.get('CustomerCode').invalid;
            const ThirdPartyDriverCodeN = this.vehiculoForm.controls.ThirdPartyDriverCode.get('CustomerName').invalid;

            const ThirdPartyInvoiceCodeC = this.vehiculoForm.controls.ThirdPartyInvoiceCode.get('CustomerCode').invalid;
            const ThirdPartyInvoiceCodeN = this.vehiculoForm.controls.ThirdPartyInvoiceCode.get('CustomerName').invalid;

            if (ThirdPartyC || ThirdPartyN || ThirdPartyDriverCodeC || ThirdPartyDriverCodeN || ThirdPartyInvoiceCodeC || ThirdPartyInvoiceCodeN) {
                $('#propietario').parent().parent().find('li.k-state-active').addClass('pestana_error');
            } else {
                $('#propietario').parent().parent().find('li.k-state-active').removeClass('pestana_error');
            }
        }
    }

    cargarTextos() {
        this.translateService.get([
            'labels.seleccionar',
            'gestion_vehiculos_vc.trasera',
            'gestion_vehiculos_vc.maletero',
            'gestion_vehiculos_vc.rtraseraIzq',
            'gestion_vehiculos_vc.rTraseraDch',
            'gestion_vehiculos_vc.aletaTrasIzq',
            'gestion_vehiculos_vc.aletaTrasDch',
            'gestion_vehiculos_vc.lunaTrasera',
            'gestion_vehiculos_vc.puertaTrasIzq',
            'gestion_vehiculos_vc.puertatrasDer',
            'gestion_vehiculos_vc.faldonIzq',
            'gestion_vehiculos_vc.faldonDer',
            'gestion_vehiculos_vc.puertaDelIzq',
            'gestion_vehiculos_vc.puertaDelDer',
            'gestion_vehiculos_vc.techo',
            'gestion_vehiculos_vc.ruedaDelIzq',
            'gestion_vehiculos_vc.ruedaDelDer',
            'gestion_vehiculos_vc.lunaDelantera',
            'gestion_vehiculos_vc.capo',
            'gestion_vehiculos_vc.frontal',
            'gestion_vehiculos_vc.aletaDelIzq',
            'gestion_vehiculos_vc.aletaDelDer',
            'labels.correcto',
            'labels.defectuoso'
        ]).subscribe(values => {
            const auxTextos = Object.keys(values).map(key => values[key]);
            this.seleccionar = auxTextos[0];

            this.trasera = auxTextos[1];
            this.maletero = auxTextos[2];
            this.rtraseraIzq = auxTextos[3];

            this.rTraseraDch = auxTextos[4];
            this.aletaTrasIzq = auxTextos[5];
            this.aletaTrasDch = auxTextos[6];

            this.lunaTrasera = auxTextos[7];
            this.puertaTrasIzq = auxTextos[8];
            this.puertatrasDer = auxTextos[9];

            this.faldonIzq = auxTextos[10];
            this.faldonDer = auxTextos[11];
            this.puertaDelIzq = auxTextos[12];

            this.puertaDelDer = auxTextos[13];
            this.techo = auxTextos[14];
            this.ruedaDelIzq = auxTextos[15];

            this.ruedaDelDer = auxTextos[16];
            this.lunaDelantera = auxTextos[17];
            this.capo = auxTextos[18];

            this.frontal = auxTextos[19];
            this.aletaDelIzq = auxTextos[20];
            this.aletaDelDer = auxTextos[21];
            this.correcto = auxTextos[22];
            this.defectuoso = auxTextos[23];
        });

        this.primerCampo = { Description: this.seleccionar, Value: 0 };
        this.defaultItem = { Description: this.seleccionar, Value: 0 };
        this.primerCampoUbi = { Description: this.seleccionar, VOLOCATIONCODE: 99 };

    }

    // Servicio que comrueba ordenes y presupuestos en curso y abiertas para el popup orders
    sacarHistorialOrdenes() {
        const vehicleChassis = this.chassis;
        this._ORCustomerVehicleService.getVehicleOR(vehicleChassis).subscribe(vehicleData =>{
            this.hayOrdenesAbiertas = vehicleData.vehicleWithOR;
            this.ordenesAbiCurCerr = vehicleData.vehicleORList;
        })
    }

    cargarPantallas() {
        switch (this.transmitter) {
            case 'gestionTerceros':
                this.textoBoxForm = 'genericos.informationBox.gestionvehiculos.textForm';
                this.isLoadingGestion = true;
                this.recepcionVehiculo = false;
                this.recepcionVO = false;
                this.gestionTerceros = true;
                this.gestionVehiculos = false;
                this.stockVO = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                this.mostrarPestanas(false);
                this.allDataCustomer = this._gestionTercerosService.observerAllDataCustomer().subscribe(val => {
                    this.customerCode = val.CustomerCode;
                    this.carData = {};
                    this.ordenStatus = '';
                    this.mostrarLupas = true;
                    this.matriculaOk = true;
                    this.ModelYearOK = true;
                    this.VinOk = true;
                    this.datosCustomer(this.customerCode);
                    this.getDefaultCarCodes();
                });
                break;
            case 'recepcionVehiculo':
                this.textoBoxForm = 'genericos.informationBox.gestionvehiculos.textForm';
                this.isLoadingGestion = false;
                this.recepcionVehiculo = true;
                this.recepcionVO = false;
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.stockVO = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                this.mostrarPestanas(false);
                this.customerCode = this._recepcionVehiculoStepsService.getCurrentCustomer();
                this.carData = {};
                this.ordenStatus = '';
                this.mostrarLupas = true;
                this.matriculaOk = true;

                this.ModelYearOK = true;
                this.VinOk = true;
                this.datosCustomer(this.customerCode);
                this.getDefaultCarCodes();
                this.combosCarroceria();
                break;
            case 'recepcionVO':
                this.textoBoxForm = 'genericos.informationBox.gestionvehiculos.textForm';
                this.isLoadingGestion = false;
                this.recepcionVehiculo = false;
                this.recepcionVO = true;
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.stockVO = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                this.mostrarPestanas(false);
                this.carData = {};
                this.ordenStatus = '';
                this.mostrarLupas = true;
                this.matriculaOk = true;
                this.ModelYearOK = true;

                this.VinOk = true;
                this.getDefaultCarCodes();
                this.combosCarroceria();
                this.cargarDatos();
                break;
            case 'gestionOr':
                this.textoBoxForm = 'genericos.informationBox.gestionvehiculos.textForm';
                this.recepcionVehiculo = false;
                this.recepcionVO = false;
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.stockVO = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = true;
                this.presupuestosTaller = false;
                this.mostrarPestanas(false);

                this.ordenSeleccionada = this._gestionService.getOrdenCompleteSeleccionada();

                this._informationBoxService.currentButton = 1;
                this.status = this.ordenSeleccionada.Status;
                this.chassis = this.ordenSeleccionada.Chassis;
                this.bandDescription = this.ordenSeleccionada.VehicleBrand.Description;

                this.url_ChassisWithCarCodes = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetByChassisWithCarCodes`;
                if (this.chassis) {
                    this.datosChassis(this.url_ChassisWithCarCodes);
                } else {
                    this.carData = {};

                    this.loadDataForm();
                }
                break;
            case 'gestionVehiculosCortesia':
                this.textoBoxForm = 'genericos.informationBox.gestionvehiculos.textForm';
                this.isLoadingGestion = false;
                this.recepcionVehiculo = false;
                this.recepcionVO = false;
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.stockVO = false;
                this.gestionVehiculosCortesia = true;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                this.ordenSeleccionada = this._dataSaveService.getDatosRowTabla('gestionVehiculosCortesia');
                this.status = this.ordenSeleccionada.Status;
                this.chassis = this.ordenSeleccionada.Chassis;
                this.bandDescription = this.ordenSeleccionada.BrandDescription;

                this.comboEstadoVehiculo();
                this.comboUbicaciones();
                this.combosCarroceria();

                this.cargarDatos();

                break;
            case 'gestionVehiculos':
                this.textoBoxForm = 'genericos.informationBox.gestionvehiculos.textForm';

                this.recepcionVehiculo = false;
                this.recepcionVO = false;
                this.ShowDataVin = false;
                this.gestionTerceros = false;
                this.gestionVehiculos = true;
                this.stockVO = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;

                this.cargarDatos();
                break;
            case 'stockVO':
                this.textoBoxForm = 'genericos.informationBox.stockvo.text01';

                this.recepcionVehiculo = false;
                this.recepcionVO = false;
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.stockVO = true;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                this.comboEstadoVehiculo();
                this.comboUbicaciones();
                this.combosCarroceria();
                this.cargarDatos();
                break;
            case 'presupuestosTaller':
                this.textoBoxForm = 'genericos.informationBox.gestionvehiculos.textForm';
                this.isLoadingGestion = true;
                this.recepcionVehiculo = false;
                this.recepcionVO = false;
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.stockVO = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.presupuestosTaller = true;
                this.mostrarPestanas(false);
                this.customerCode = this.codeOfCustomer;
                this.carData = {};
                this.ordenStatus = '';
                this.mostrarLupas = true;
                this.matriculaOk = true;
                this.ModelYearOK = true;
                this.VinOk = true;
                this.datosCustomer(this.customerCode);
                this.getDefaultCarCodes();
                this.combosCarroceria();
                break;
        }
    }

    cargarDatos() {
        this.isNew = false;
        this.isNew = this._dataSaveService.getCustomerNew(this.transmitter).isNew;
        this.desactivarGestExp = this.isNew;
        this.formularioGuardado = this._dataSaveService.getFormulario(this.transmitter) ? this._dataSaveService.getFormulario(this.transmitter).form : null;

        if (this.formularioGuardado) {
            if (this.isNew) {
                this._informationBoxService.currentButton = 1;
                this.statusFormSend = 'new';
                this.carData = {};
                this.ordenStatus = '';
                this.getDefaultCarCodes();
                this.matriculaOk = true;
                this.ModelYearOK = true;
                this.VinOk = true;
                this.mostrarPestanas(true);
            } else {
                this.mostrarPestanas(false);
                if (this.transmitter === 'stockVO') {
                    this._informationBoxService.currentButton = 2;
                } else {
                    this._informationBoxService.currentButton = 1;
                }
                this.getDatosTablaGestionForm = this._dataSaveService.getDatosRowTabla(this.transmitter);
                if (this.getDatosTablaGestionForm && !this.comprobarObjeto(this.getDatosTablaGestionForm)) {

                    this.bandDescription = this.getDatosTablaGestionForm.BrandDescription;

                    this.status = this.getDatosTablaGestionForm.Status;
                    this.customerCode = this.getDatosTablaGestionForm.CustomerCode;
                    this.chassis = this.getDatosTablaGestionForm.Chassis;

                    this.carData = this._gestionVehiculosService.getGetByChassisWithCarCodes();
                    this.gestionDatosChassis(this.carData);
                    this.sacarHistorialOrdenes();
                }
            }
            this.crearFormularioVehiculosCargado(this.formularioGuardado);

            if (this.transmitter === 'gestionVehiculosCortesia' || this.transmitter === 'stockVO') {
                this.formularioGestion = this._dataSaveService.getFormularioGestion(this.transmitter) ? this._dataSaveService.getFormularioGestion(this.transmitter).form : null;
                this.formularioCarroceria = this._dataSaveService.getFormularioCarroceria(this.transmitter) ? this._dataSaveService.getFormularioCarroceria(this.transmitter).form : null;
                this.formularioCaractVehic = this._dataSaveService.getFormularioCaractVehic(this.transmitter) ? this._dataSaveService.getFormularioCaractVehic(this.transmitter).form : null;
                this.formularioCompraVehic = this._dataSaveService.getFormularioCompraVehic(this.transmitter) ? this._dataSaveService.getFormularioCompraVehic(this.transmitter).form : null;

                if (this.formularioGestion) {
                    this.crearFormularioGestionRecuperado(this.formularioGestion);
                } else {
                    this.crearFormularioGestion();
                }

                if(this.formularioCaractVehic){
                    this.crearFormularioCaractVehicRecuperado(this.formularioCaractVehic);
                }else{
                    this.crearFormularioCaractVehic();
                }

                if(this.formularioCompraVehic){
                    this.crearFormularioCompraVehicRecuperado(this.formularioCompraVehic);
                }else{
                    this.crearFormularioCompraVehic();
                }

                if (this.formularioCarroceria) {
                    this.crearFormularioCarroceriaRecuperado(this.formularioCarroceria);
                } else {
                    this.crearFormularioCarroceria();
                }
            }
        } else {
            if (this.isNew) {
                this.mostrarPestanas(true);
                this._informationBoxService.currentButton = 1;
                this.statusFormSend = 'new';
                this.custumerData = {};
                this.carData = {};
                this.ordenStatus = '';
                this.getDefaultCarCodes();
                this.matriculaOk = true;
                this.ModelYearOK = true;
                this.VinOk = true;
                this.crearFormularioVacio();
                if (this.transmitter === 'gestionVehiculosCortesia' || this.transmitter === 'stockVO') {
                    this.crearFormularioGestion();
                    this.crearFormularioCarroceria();
                }
            } else {
                this.mostrarPestanas(false);
                this.getDatosTablaGestionForm = this._dataSaveService.getDatosRowTabla(this.transmitter);

                if (this.getDatosTablaGestionForm && !this.comprobarObjeto(this.getDatosTablaGestionForm)) {
                    if (this.transmitter === 'stockVO') {
                        this._informationBoxService.currentButton = 2;
                    } else {
                        this._informationBoxService.currentButton = 1;
                    }
                    this.status = this.getDatosTablaGestionForm.Status;

                    this.customerCode = this.getDatosTablaGestionForm.CustomerCode;
                    this.chassis = this.getDatosTablaGestionForm.Chassis;

                    if (this.transmitter === 'gestionVehiculos') {
                        this.url_ChassisWithCarCodes = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetByChassisWithCarCodes`;
                    } else if (this.transmitter === 'gestionVehiculosCortesia' || this.transmitter === 'stockVO') {
                        this.url_ChassisWithCarCodes = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/GetByChassisWithCarCodes`;
                    }
                    this.datosChassis(this.url_ChassisWithCarCodes);

                    if (this.transmitter === 'gestionVehiculosCortesia' || this.transmitter === 'stockVO') {
                        this.estadoCarroceria();
                    }
                    this.sacarHistorialOrdenes();
                }
            }
        }
    }

    comprobarBrandCode() {
        if ((!this.deshabilitarCampos || !this.isModal) && ((this.BrandCode === 'CIT' && (this.filial === 'ER' || this.filial === 'AC')) || (this.BrandCode === 'PEU' && this.filial === 'AP'))) {
            this.mostrarLupas = true;
            this.vehiculoForm.get('Opb').enable();
            this.vehiculoForm.get('ModelCode').enable();
        } else {
            this.mostrarLupas = false;
            this.vehiculoForm.get('Opb').disable();
            this.vehiculoForm.get('Opb').setValue('', { emitEvent: false });
            this.vehiculoForm.get('OpbCode').setValue('', { emitEvent: false });
        }
    }

    estado(estado) {
        switch (estado) {
            case 0:
                return 'Activo';
            case 1:
                return 'Inactivo';
            case 2:
                return '';
        }
    }

    mostrarPestanas(isNew) {
        switch (this.transmitter) {
            case 'gestionTerceros':
                this.showVehiculo = true;
                this.showPropietario = true;
                this.showGarantia = true;
                this.showOR = false;
                this.showSeguridad = true;
                this.showGestion = false;
                this.showEstadoCarroceria = false;
                this.showCitas = false;
                break;
            case 'recepcionVehiculo':
                this.showVehiculo = true;
                this.showPropietario = true;
                this.showGarantia = true;
                this.showOR = false;
                this.showSeguridad = true;
                this.showGestion = false;
                this.showEstadoCarroceria = false;
                this.showCitas = false;
                break;
            case 'recepcionVO':
                this.showVehiculo = true;
                this.showPropietario = false;
                this.showGarantia = true;
                this.showOR = false;
                this.showSeguridad = true;
                this.showGestion = false;
                this.showEstadoCarroceria = false;
                this.showCitas = false;
                break;
            case 'gestionOr':
                this.showVehiculo = true;
                this.showPropietario = true;
                this.showGarantia = true;
                this.showOR = false;
                this.showSeguridad = true;
                this.showGestion = false;
                this.showEstadoCarroceria = false;
                this.showCitas = false;
                break;
            case 'gestionVehiculos':
                if (isNew) {
                    this.showVehiculo = true;
                    this.showPropietario = true;
                    this.showGarantia = true;
                    this.showOR = false;
                    this.showSeguridad = true;
                    this.showGestion = false;
                    this.showEstadoCarroceria = false;
                    this.showCitas = false;
                } else {
                    this.showVehiculo = true;
                    this.showPropietario = true;
                    this.showGarantia = true;
                    this.showOR = true;
                    this.showSeguridad = true;
                    this.showGestion = false;
                    this.showEstadoCarroceria = false;
                    this.showCitas = false;
                }
                break;

            case 'gestionVehiculosCortesia':
                if (isNew) {
                    this.showVehiculo = true;
                    this.showPropietario = false;
                    this.showGarantia = true;
                    this.showOR = false;
                    this.showSeguridad = true;
                    this.showGestion = true;
                    this.showEstadoCarroceria = true;
                    this.showCitas = true;
                } else {
                    this.showVehiculo = true;
                    this.showPropietario = false;
                    this.showGarantia = true;
                    this.showOR = true;
                    this.showSeguridad = true;
                    this.showGestion = true;
                    this.showEstadoCarroceria = true;
                    this.showCitas = true;
                }
                break;
            case 'stockVO':
                this.showVehiculo = true;
                this.showPropietario = false;
                this.showGarantia = true;
                this.showOR = true;
                this.showSeguridad = true;
                this.showGestion = true;
                this.showEstadoCarroceria = true;
                this.showCitas = false;
                break;
            case 'presupuestosTaller':
                this.showVehiculo = true;
                this.showPropietario = true;
                this.showGarantia = true;
                this.showOR = false;
                this.showSeguridad = true;
                this.showGestion = false;
                this.showEstadoCarroceria = false;
                this.showCitas = false;
                break;
        }

    }

    getValueControlThirdParty() {
        const campoCode = this.vehiculoForm.get('ThirdParty').get('CustomerCode').hasError('required') && this.vehiculoForm.get('ThirdParty').get('CustomerCode').value === '';
        const campoName = this.vehiculoForm.get('ThirdParty').get('CustomerName').hasError('required') && this.vehiculoForm.get('ThirdParty').get('CustomerName').value === '';
        const campoFull = campoCode || campoName;
        if (campoFull) {
            this.placeholderCustomerCode = this.textObligado;
            this.placeholderCustomerName = this.textObligado;
        } else {
            this.placeholderCustomerCode = '';
            this.placeholderCustomerName = '';
        }
        return campoFull;
    }

    getValueControlThirdPartyDriverCode() {
        const campoCode = this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerCode').hasError('required') && this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerCode').value === '';
        const campoName = this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerName').hasError('required') && this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerName').value === '';
        const campoFull = campoCode || campoName;
        if (campoFull) {
            this.placeholdercustomercodedriver = this.textObligado;
            this.placeholdercustomernamedriver = this.textObligado;
        } else {
            this.placeholdercustomercodedriver = '';
            this.placeholdercustomernamedriver = '';
        }
        return campoFull;
    }

    getValueControlThirdPartyInvoiceCode() {
        const campoCode = this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerCode').hasError('required') && this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerCode').value === '';
        const campoName = this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerName').hasError('required') && this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerName').value === '';
        const campoFull = campoCode || campoName;
        if (campoFull) {
            this.placeholdercustomercodeinvoice = this.textObligado;
            this.placeholdercustomernameinvoice = this.textObligado;
        } else {
            this.placeholdercustomercodeinvoice = '';
            this.placeholdercustomernameinvoice = '';
        }
        return campoFull;
    }

    comprobarValidezVinPlate() {

        const matriculaVacia = this.vehiculoForm.get('PlateNumber').hasError('required') && (this.vehiculoForm.get('PlateNumber').value === '' || this.vehiculoForm.get('PlateNumber').value === null);
        const VinVacia = this.vehiculoForm.get('Vin').hasError('required') && (this.vehiculoForm.get('Vin').value === '' || this.vehiculoForm.get('Vin').value === null);

        if (matriculaVacia || VinVacia || !this.matriculaOk || !this.VinOk || this.matriculaDuplicate || this.VinDuplicate) {
            return true;
        } else {
            return false;
        }
    }

    getValueControl(name) {
        const campoFull = this.vehiculoForm.get(name).hasError('required') && (this.vehiculoForm.get(name).value === '' || this.vehiculoForm.get(name).value === null);
        if (campoFull) {
            switch (name) {
                case 'PlateNumber':
                    this.placeholderPlateNumber = this.textObligado;
                    break;
                case 'Vin':
                    this.placeholderVin = this.textObligado;
                    break;
                case 'Description':
                    this.placeholderDescripcion = this.textObligado;
                    break;
                case 'ModelYear':
                    this.placeholderModelYear = this.textObligado;
                    break;
            }
        }
        return campoFull;
    }

    blurElement(name) {
        if (this.vehiculoForm.get(name).hasError('required') && this.vehiculoForm.get(name).value === '') {
            switch (name) {
                case 'PlateNumber':
                    this.placeholderPlateNumber = this.textObligado;
                    break;
                case 'Vin':
                    this.placeholderVin = this.textObligado;
                    break;
                case 'Description':
                    this.placeholderDescripcion = this.textObligado;
                    break;
                case 'ModelYear':
                    this.placeholderModelYear = this.textObligado;
                    break;
            }
        } else {
            switch (name) {
                case 'PlateNumber':
                    this.placeholderPlateNumber = '';
                    break;
                case 'Vin':
                    this.placeholderVin = '';
                    break;
                case 'Description':
                    this.placeholderDescripcion = '';
                    break;
                case 'ModelYear':
                    this.placeholderModelYear = '';
                    break;
            }
        }
    }

    comprobarObjeto(item) {
        const auxItemString = JSON.stringify(item);
        const auxObjetoVacio = '{}';
        if (auxItemString === auxObjetoVacio) {
            return true;
        } else {
            return false;
        }

    }

    comprobarAltura() {
        let pestanasGrande = false;
        if (this.gestionTerceros || this.gestionVehiculos || this.stockVO) {
            pestanasGrande = true;

        } else {
            pestanasGrande = false;
        }
        return pestanasGrande;
    }

    datosCustomer(customerCode) {
        const _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/GetBySearchCode`;
        const parametros = {
            'searchCode': customerCode
        };

        this._dataVehiculosService.getCustumerByCode(_URL_, parametros).subscribe((data: any) => {
            if (this.presupuestosTaller && this.isLoadingGestion) {
                this.isLoadingGestion = false;
            }
            const auxdata = data.Response;
            if (auxdata) {
                this.custumerData = auxdata;
                this.CustomerCodePhone = this.custumerData.CustomerCode;
                this.TelephonePortable = this.custumerData.TelephonePortable;

                if (this.gestionTerceros || this.gestionOr || this.recepcionVehiculo || this.presupuestosTaller) {
                    this.formularioDesdeTerceros(this.custumerData);
                }
            }
        });
    }

    getDefaultCarCodes() {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetDefaultCarCodes`;
        const params = {};
        this._dataVehiculosService.getDefaultCarCodes(_URL_, params).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.carData['VehicleCodes'] = auxdata;
                this.segurity[0]['gridView'] = {
                    data: this.carData['VehicleCodes'],
                    total: this.carData['VehicleCodes'].length
                };
            }
        });
    }
    reactivarVehiculo() {
        const b = {
            searchValue: this.chassis,
        };
        const _URL_ = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/ReactivateByChassis`;
        this._dataVehiculosService.reactivateByChassis(_URL_, b).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {

                this.generic_popupName = 'vehiculoReactivado';
                this.generic_aspa = false;
                this.generic_isButtonOk = true;
                this.generic_isButtonCancel = false;
                this.generic_title = 'gestion_vehiculos_vc.gestionV';
                this.generic_message = 'gestion_vehiculos_vc.msgPopupReacti';
                this.generic_textButtonOk = 'labels.aceptar';
                this.generic_textButtonCancel = 'labels.no';
                this.showModalGeneric = true;
            }
        });
    }


    datosChassis(url) {
        const parametros = {
            'searchValue': this.chassis
        };

        this._dataVehiculosService.getCarByChassis(url, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.carData = auxdata;
                this._adjuntarDocumentosService.setMediaFileList(this.carData.VehicleMediaFileList);
                this._buttonsActivateService.actualizarBtnAdjuntoHasItems(this.carData.VehicleMediaFileList.length > 0);

                if (this.carData.RevocaDate) {
                    this.siBaja = true;
                    this.bajaVehiculo = this.bajaText + this._globals.getDateFormatMDY(this.carData.RevocaDate);
                } else {
                    this.siBaja = false;
                    this.bajaVehiculo = '';
                }



                if (this.transmitter === 'gestionVehiculosCortesia' || this.transmitter === 'stockVO') {
                    this.crearFormularioGestion();
                    this.crearFormularioCaractVehic();
                    this.crearFormularioCompraVehic();
                }

                this._gestionVehiculosService.setGetByChassisWithCarCodes(this.carData);
                this.gestionDatosChassis(auxdata);
                this.loadDataForm();
            }
        });
    }

    gestionDatosChassis(auxdata) {
        if (auxdata.LastRepairOrder) {
            const LastRepairOrder = auxdata.LastRepairOrder;
            LastRepairOrder.order = LastRepairOrder.RepairPrefix + '-' + LastRepairOrder.RepairNumber;
            LastRepairOrder.state = this.getFactTranslate(LastRepairOrder.StateCode);
            auxdata.LastRepairOrder = LastRepairOrder;
            this.ordenStatus = LastRepairOrder.order + ' ' + LastRepairOrder.state;
        } else {
            this.ordenStatus = '';
        }
        this.internalUse = this.carData.InternalVehicleUse;

        this.vehicleState = this.estado(this.carData.VehicleState);

        this.PlateNumber = this.carData['PlateNumber'];
        this.Vin = this.carData['Vin'];

        this.registrationDate = this.carData['RegistrationDate'] != null ? this._globals.getDateFormatMDY(this.carData['RegistrationDate']) : null;

        this.VehicleBrand = this.carData.VehicleBrand;

        this.ThirdParty = this.carData['ThirdParty'];
        this.ThirdPartyDriverCode = this.carData['ThirdPartyDriverCode'];
        this.ThirdPartyInvoiceCode = this.carData['ThirdPartyInvoiceCode'];

        this.ThirdPartyCustomerCode = this.carData['ThirdParty'] ? this.carData['ThirdParty']['CustomerId'] : null; // solo CustomerId
        this.ThirdPartyDriverCodeDriverCode = this.carData['ThirdPartyDriverCode'] ? this.carData['ThirdPartyDriverCode']['CustomerId'] : null; // solo CustomerId
        this.ThirdPartyInvoiceCodeCustomerInvoiceCode = this.carData['ThirdPartyInvoiceCode'] ? this.carData['ThirdPartyInvoiceCode']['CustomerId'] : null; //solo CustomerId

        // Este customerId es el que necesitamos para rellenar los datos de la pestaña OR
        this.CustomerId = this.carData['ThirdParty']['CustomerId'] ? this.CustomerId = this.carData['ThirdParty']['CustomerId'] : null;
        this._gestionTercerosService.setCustomer(this.CustomerId);
        this.CustomerCodePhone = this.carData.CustomerCode; // tipo: 024148E-11482  (sera CustomerId o CustomerCode cada vez es distinto)
        this.TelephonePortable = this.carData['ThirdParty']['TelephonePortable'] ? this.TelephonePortable = this.carData['ThirdParty']['TelephonePortable'] : null;
        this.CustomerName = this.carData['ThirdParty']['CustomerName'] ? this.CustomerName = this.carData['ThirdParty']['CustomerName'] : null;
        this.CustomerCode = this.carData['ThirdParty']['CustomerCode'] ? this.CustomerCode = this.carData['ThirdParty']['CustomerCode'] : null;
        this.FiscalCode = this.carData['ThirdParty']['FiscalCode'] ? this.FiscalCode = this.carData['ThirdParty']['FiscalCode'] : null;
        this.TelephoneHome = this.carData['ThirdParty']['TelephoneHome'] ? this.TelephoneHome = this.carData['ThirdParty']['TelephoneHome'] : null;

        this.segurity[0]['gridView'] = {
            data: this.carData['VehicleCodes'],
            total: this.carData['VehicleCodes'].length
        };
    }

    // Servicio que devuelve los cadigos de garantia para pestaña garantia
    getCodigos() {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/GaranteeExtensionsService.svc/GetAll`;
        const params = {
            'searchValue': '',
            'pageInfo': {
                'Number': this.pageNumber,
                'Size': this.pageSize
            }
        };
        this._dataVehiculosService.getCodigosGarantia(_URL_, params).subscribe(data => {
            const auxdata = data.Response.Content;
            if (auxdata) {
                this.codigosGarantia = auxdata;

                this.CLIENTCODE = this.codigosGarantia[0].CLIENTCODE;
                this.COMPANYCODE = this.codigosGarantia[0].COMPANYCODE;

            }
        });
    }

    closePopupVin() {
        const datosForm = this.vehiculoForm.getRawValue();
        this.ShowDataVin = false; // falso popup
    }

    savePopupVin() {
        this.ShowDataVin = false; // falso popup
        const datosForm = this.vehiculoForm.getRawValue();

        const b = {
            'chassis': this.chassis,
            'vin': datosForm.Vin,
            'plate': datosForm.PlateNumber
        };
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/UpdateVinPlate`;
        this._dataVehiculosService.updateVinPlate(_URL_, b).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.translateService.get('genericos.toastr.successfulSave').subscribe(text => {
                    this.toastr.success(text);
                });

            }
        });
    }

    // Al inicio para abrir popup
    comprobarErroresMatriculaVIn() {
        if (!this.PlateNumber || this.PlateNumber === '' || !this.Vin || this.Vin === '') {
            this.tipo = 'sinDAtos';
            this.ShowDataVin = true;
        } else {
            this.validarMatriculaVin(this.carData['PlateNumber'], this.carData['Vin']);
        }
    }

    validarMatriculaVin(PlateNumber, Vin) {
        if (PlateNumber) {
            this.isValidMatricula(PlateNumber);
        } else {
            this.matriculaOk = true;
        }
        if (Vin) {
            this.isValidVin(Vin);
        } else {
            this.VinOk = true;
        }

        if (!this.matriculaOk || !this.VinOk) {
            this.tipo = 'datosErroneos';
            this.ShowDataVin = true;
        } else {
            this.comprobarSiDuplicados(PlateNumber, Vin);
        }
    }


    validateModelYear() {
        const modelYear = this.vehiculoForm.get('ModelYear').value;
        if (modelYear === null || modelYear === undefined || modelYear === '') {
            this.vehiculoForm.get('ModelYear').setValue(null, { emitEvent: false });
        }
        this.isValidModelYear(modelYear);
    }

    isValidModelYear(ModelYear) {
        const modelYear = ModelYear;
        if (modelYear === null) {
            this.anioKO = false;
            this.longitudKO = false;
        } else if (( modelYear >= this.fisrtYear) && ( modelYear <= this.currentYear)) {
            this.anioKO = false;
        } else {
            this.anioKO = true;
            this.longitudKO = true;
        }
    }

    comprobarSiDuplicados(PlateNumber, Vin) {
        this.isDuplicatePlate(PlateNumber);
        this.isDuplicateVin(Vin);
        if (this.matriculaDuplicate || this.VinDuplicate) {
            this.tipo = 'datosDuplicados';
            this.ShowDataVin = true;
        }
    }

    isDuplicatePlate(PlateNumber) {
        this.matriculaDuplicate = false;
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/ExistsPlateByChassis`;
        const params = {
            'VehicleChassis': this.chassis,
            'VehiclePlate': PlateNumber
        };
        this._dataVehiculosService.isDuplicatePlate(_URL_, params).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.matriculaDuplicate = auxdata.Data;
            }
        });
    }

    isDuplicateVin(Vin) {
        this.VinDuplicate = false;
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/ExistsVinByChassis`;
        const params = {
            'VehicleChassis': this.chassis,
            'VehicleVin': Vin
        };
        this._dataVehiculosService.isDuplicateVin(_URL_, params).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.VinDuplicate = auxdata.Data;
                if (!this.VinDuplicate) {
                    this.searchOpb(Vin);
                }
            }
        });
    }

    isValidMatricula(PlateNumber) {
        const datosForm = this.vehiculoForm.getRawValue();


        this.matriculaOk = true; //por defecto esta bien escrita si esta vacio
        // maximo 10 minimo 3
        if (PlateNumber.length > 2 && PlateNumber.length < 11) {
            const expreg = new RegExp(/^[A-Z0-9]+$/g);
            this.matriculaOk = expreg.test(PlateNumber);

        } else {
            this.matriculaOk = false;
        }
    }

    isValidVin(vin) {
        this.VinOk = true;
        const expreg = new RegExp(/^[A-Z0-9]+$/g);
        if (vin.length === 17) {
            this.VinOk = expreg.test(vin);
        } else {
            this.VinOk = false;
        }
    }

    changeBrand(event) {
        const datosForm = this.vehiculoForm.getRawValue();
    }

    searchOpb(Vin) {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleModelService.svc/GetOPBCodeByVIN`;
        const params = {
            searchValue: Vin
        };
        this._dataVehiculosService.isDuplicateVin(_URL_, params).subscribe(data => {
            const auxdata = data; // devuelve "VDU4"
            if (auxdata) {
                this.vehiculoForm.get('OpbCode').setValue(auxdata, { emitEvent: false });
            }
        });
    }

    //Servicio que devuelve las marcas de los coches
    vehicles() {
        this.paginacionInicial();

        const params = {
            'searchValue': '',
            'pageInfo': {
                'Number': this.pageNumber,
                'Size': 320
            }
        };
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleBrandService.svc/GetAllVehicleBrands`;
        this._dataVehiculosService.getDataAllVehicles(_URL_, params).subscribe((data: any) => {
            const auxdata = data.Response.Content;
            if (auxdata) {
                this.GetAllVehicles = auxdata;
            }
        });
    }

    valueBrandCode(value: any): void {
        this.vehiculoForm.get('BrandCode').setValue(value.BrandCode, { emitEvent: false });
    }

    valueGuarantee(value: any): void {
    }

    valueEngine(value: any): void {
    }

    deshabilitandoCampos() {
        //De momento solo tengo en cuenta el modo consulta y dejo de para mas adelante el modoEdicion || !this.modoEdicion
        if (this.formMode || this.isModal) {

            this.vehiculoForm.get('InternalVehicleUse').disable();
            this.vehiculoForm.get('ThirdParty').get('CustomerCode').disable();
            this.vehiculoForm.get('ThirdParty').get('CustomerName').disable();
            this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerCode').disable();
            this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerName').disable();
            this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerCode').disable();
            this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerName').disable();
            this.vehiculoForm.get('CustomerPrescriber').get('CustomerCode').disable();
            this.vehiculoForm.get('CustomerPrescriber').get('CustomerName').disable();
            this.vehiculoForm.get('CustomerKeeper').get('CustomerCode').disable();
            this.vehiculoForm.get('CustomerKeeper').get('CustomerName').disable();
        } else {
            if (this.gestionTerceros) {
                this.vehiculoForm.get('InternalVehicleUse').enable();
                this.vehiculoForm.get('ThirdParty').get('CustomerCode').disable();
                this.vehiculoForm.get('ThirdParty').get('CustomerName').disable();
                this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerCode').disable();
                this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerName').disable();
                this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerCode').disable();
                this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerName').disable();
                this.vehiculoForm.get('CustomerPrescriber').get('CustomerCode').disable();
                this.vehiculoForm.get('CustomerPrescriber').get('CustomerName').disable();
                this.vehiculoForm.get('CustomerKeeper').get('CustomerCode').disable();
                this.vehiculoForm.get('CustomerKeeper').get('CustomerName').disable();
            } else {
                this.vehiculoForm.get('ThirdParty').get('CustomerCode').enable();
                this.vehiculoForm.get('ThirdParty').get('CustomerName').enable();
                this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerCode').enable();
                this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerName').enable();
                this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerCode').enable();
                this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerName').enable();
                this.vehiculoForm.get('CustomerPrescriber').get('CustomerCode').enable();
                this.vehiculoForm.get('CustomerPrescriber').get('CustomerName').enable();
                this.vehiculoForm.get('CustomerKeeper').get('CustomerCode').enable();
                this.vehiculoForm.get('CustomerKeeper').get('CustomerName').enable();
                // no llega ese tipo de string  'RESERVADO' llega 'EC' 'RE'
                if (this.status === 'RE') {
                    this.vehiculoForm.get('InternalVehicleUse').disable();
                } else {
                    this.vehiculoForm.get('InternalVehicleUse').enable();
                }
            }
        }
    }

    saveDataForm() {
        const datosForm = this.vehiculoForm.getRawValue();
        const auxForm = {
            'form': datosForm
        };
        this._dataSaveService.setFormulario(this.transmitter, auxForm);
        this._dataVehiculosService.setCargadoFromulario(true);
    }

    estadoCarroceria() {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleValuationService.svc/GetCurrentByChassis`;
        const params = { 'searchValue': this.chassis };
        this._sendData.estadoCarroceria(_URL_, params).subscribe(data => {
            const auxdata = data.Response;

            if (auxdata) {
                this.creationDate = auxdata.CreationDate;
                this.ID = auxdata.ID;
                if (auxdata && auxdata.VehicleValuationDetailList) {
                    this.vehicleValuationDetailList = auxdata.VehicleValuationDetailList;
                }
            }
            this.crearFormularioCarroceria();

        });

    }

    marcarValoresCarroceria(item) {
        switch (item.PointID) {
            case 0:
                this.carroceria.get('frontal').setValue(item.PointState, { emitEvent: false });
                break;
            case 1:
                this.carroceria.get('capo').setValue(item.PointState, { emitEvent: false });
                break;
            case 2:
                this.carroceria.get('ruedaDelDer').setValue(item.PointState, { emitEvent: false });
                break;
            case 3:
                this.carroceria.get('ruedaDelIzq').setValue(item.PointState, { emitEvent: false });
                break;
            case 4:
                this.carroceria.get('aletaDelDer').setValue(item.PointState, { emitEvent: false });
                break;
            case 5:
                this.carroceria.get('aletaDelIzq').setValue(item.PointState, { emitEvent: false });
                break;
            case 6:
                this.carroceria.get('lunaDelantera').setValue(item.PointState, { emitEvent: false });
                break;
            case 7:
                this.carroceria.get('puertaDelDer').setValue(item.PointState, { emitEvent: false });
                break;
            case 8:
                this.carroceria.get('puertaDelIzq').setValue(item.PointState, { emitEvent: false });
                break;
            case 9:
                this.carroceria.get('faldonDer').setValue(item.PointState, { emitEvent: false });
                break;
            case 10:
                this.carroceria.get('faldonIzq').setValue(item.PointState, { emitEvent: false });
                break;
            case 11:
                this.carroceria.get('puertatrasDer').setValue(item.PointState, { emitEvent: false });
                break;
            case 12:
                this.carroceria.get('puertaTrasIzq').setValue(item.PointState, { emitEvent: false });
                break;
            case 13:
                this.carroceria.get('techo').setValue(item.PointState, { emitEvent: false });
                break;
            case 14:
                this.carroceria.get('rTraseraDch').setValue(item.PointState, { emitEvent: false });
                break;
            case 15:
                this.carroceria.get('rtraseraIzq').setValue(item.PointState, { emitEvent: false });
                break;
            case 16:
                this.carroceria.get('lunaTrasera').setValue(item.PointState, { emitEvent: false });
                break;
            case 17:
                this.carroceria.get('maletero').setValue(item.PointState, { emitEvent: false });
                break;
            case 18:
                this.carroceria.get('trasera').setValue(item.PointState, { emitEvent: false });
                break;
            case 19:
                this.carroceria.get('aletaTrasDch').setValue(item.PointState, { emitEvent: false });
                break;
            case 20:
                this.carroceria.get('aletaTrasIzq').setValue(item.PointState, { emitEvent: false });
                break;

        }
    }

    calendarioCitas({ sender, rowIndex, dataItem }) {
        this._redirectService.redirectionTaller(this.moduloTaller, 3001, null);
    }

    public fichas() {
        this._redirectService.redirectionGeneral(this.moduloGeneral, 1001, null);
    }

    gestionarExpediente() {
        this._redirectService.redirectionVO(this.moduloVO, 7004, null);
    }

    tablaCitas() {
        const _URL_ = `${environment.ENTORNO}Services/General/AppointmentsService.svc/FindAppointmentCarRegistry`;
        const datosForm = this.vehiculoForm.getRawValue();
        const params = {
            'startCarAppointmentDeliveryDate': null,
            'endCarAppointmentDeliveryDate': null,
            'startCarAppointmentReturnedDate': null,
            'endCarAppointmentReturnedDate': null,
            'startCarAppointmentPreviewedReturnDate': null,
            'endCarAppointmentPreviewedReturnDate': null,
            'chassis': this.chassis,
            'plate': datosForm.PlateNumber,
            'VIN': datosForm.Vin,
            'appointmentCarState': '',
            'deliveryLocationCode': '',
            'returnedLocationCode': '',
            'pageInfo': { 'Number': 1, 'Size': 20 }
        };

        this._sendData.getCitas(_URL_, params).subscribe(data => {
            const auxdata = data.Response.Content;
            if (auxdata) {
                this.citas = auxdata;
                this.citas.forEach(d => {
                    d.DeliveryDate = this._globals.getDateFormatMDY(d.DeliveryDate);
                    d.PreviewedReturnDate = this._globals.getDateFormatMDY(d.PreviewedReturnDate);
                });

                this.gridView = {
                    data: this.citas,
                    total: this.citas.length
                };

            }
        });
    }



    comboEstadoVehiculo() {
        this.primerCampo = {
            Description: this.seleccionar,
            Value: 0
        };
        const _URL_ = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/GetAllStateCarTypes`;
        this._sendData.getAllStateCarTypes(_URL_).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.vehicleStates = auxdata;
                this.vehicleStates.unshift(this.primerCampo);
            }
        });

    }

    comboUbicaciones() {
        this.primerCampo = {
            Description: this.seleccionar,
            VOLOCATIONCODE: 99
        };
        const _URL_ = `${environment.ENTORNO}Services/VO/VOLocationsService.svc/GetAll`;
        const params = { 'searchValue': '' };
        this._sendData.getUbicaciones(_URL_, params).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.ubicaciones = auxdata;
                this.ubicaciones.unshift(this.primerCampoUbi);
            }
        });
    }



    estadoPieza(name, event) {
        this.carroceria.get(name).setValue(event, { emitEvent: false });
    }

    combosCarroceria() {
        if (this.pais === 'es') {
            this.comboCarroceria = [

                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ],
                [
                    { PointState: 0, PointStateDescription: 'Correcto' },
                    { PointState: 1, PointStateDescription: 'defectuoso' }
                ]

            ];
        }
    }


    crearFormularioVehiculosCargado(carData) {
        this.statusFormSend = 'edit';
        this.formMode = this._authService.getUserRole();

        if (this.formMode) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = this.isModal ? true : false;
        }
        this.BrandCode = carData['BrandCode'];
        this.vehiculoForm = new FormGroup({

            registrarionSource: new FormControl({ value: carData['registrarionSource'] ? carData['registrarionSource'] : 'DMS', disabled: this.deshabilitarCampos }),
            sfVehicleId: new FormControl({ value: carData['sfVehicleId'] ? carData['sfVehicleId'] : null, disabled: this.deshabilitarCampos }),

            PlateNumber: new FormControl({ value: carData['PlateNumber'], disabled: this.deshabilitarCampos }, Validators.required),  //[Validators.required, Validators.maxLength(10)]),
            Vin: new FormControl({ value: carData['Vin'], disabled: this.deshabilitarCampos }, Validators.required),
            Brand: new FormControl({ value: carData['Brand'], disabled: this.deshabilitarCampos }),

            BrandCode: new FormControl({ value: carData['BrandCode'], disabled: this.deshabilitarCampos }),

            GuaranteeExtCode: new FormControl({ value: carData['GuaranteeExtCode'] ? carData['GuaranteeExtCode'] : '', disabled: this.deshabilitarCampos }),
            EnginePower: new FormControl({ value: carData['EnginePower'] ? carData['EnginePower'] : '', disabled: this.deshabilitarCampos }),
            Type: new FormControl({ value: carData['Type'] ? carData['Type'] : 'T', disabled: this.deshabilitarCampos }),
            ModelCode: new FormControl({ value: carData['ModelCode'] ? carData['ModelCode'] : '', disabled: this.deshabilitarCampos }),
            ModelYear: new FormControl({ value: carData['ModelYear'] ? carData['ModelYear'] : null, disabled: this.deshabilitarCampos }, [Validators.required, modelYearValidator()]),
            VehicleModification: new FormControl({ value: carData['VehicleModification'] ? carData['VehicleModification'] : '', disabled: this.deshabilitarCampos }),
            LastInvoiceAmount: new FormControl({ value: carData['LastInvoiceAmount'] ? carData['LastInvoiceAmount'] : 0, disabled: this.deshabilitarCampos }),
            OpbCode: new FormControl({ value: carData['OpbCode'] ? carData['OpbCode'] : '', disabled: true }),
            Opb: new FormControl({ value: carData['Opb'] ? carData['Opb'] : '', disabled: this.deshabilitarCampos }),

            LastRepairDate: new FormControl({ value: carData['LastRepairDate'] ? carData['LastRepairDate'] : null, disabled: true }),
            NextVisitDate: new FormControl({ value: carData['NextVisitDate'] ? carData['NextVisitDate'] : null, disabled: this.deshabilitarCampos }),

            InternalVehicleUse: new FormControl(this.carData['InternalVehicleUse'] ? carData['InternalVehicleUse'] : 'NI'),
            OrganizationNumber: new FormControl({ value: carData['OrganizationNumber'] ? carData['OrganizationNumber'] : '', disabled: this.deshabilitarCampos }),
            Description: new FormControl({ value: carData['Description'] ? carData['Description'] : '', disabled: this.deshabilitarCampos }, Validators.required),
            KM: new FormControl({ value: carData['KM'] ? carData['KM'] : '', disabled: this.deshabilitarCampos }),
            Comment: new FormControl({ value: carData['Comment'] ? carData['Comment'] : '', disabled: this.deshabilitarCampos }),

            ThirdParty: new FormGroup({
                CustomerId: new FormControl(carData['ThirdParty']['CustomerId'] ? carData['ThirdParty']['CustomerId'] : null, Validators.required),
                CustomerCode: new FormControl(carData['ThirdParty']['CustomerCode'] ? carData['ThirdParty']['CustomerCode'] : null, Validators.required),
                CustomerName: new FormControl(carData['ThirdParty']['CustomerName'] ? carData['ThirdParty']['CustomerName'] : null, Validators.required),
            }),
            ThirdPartyDriverCode: new FormGroup({
                CustomerId: new FormControl(carData['ThirdPartyDriverCode']['CustomerId'] ? carData['ThirdPartyDriverCode']['CustomerId'] : null, Validators.required),
                CustomerCode: new FormControl(carData['ThirdPartyDriverCode']['CustomerCode'] ? carData['ThirdPartyDriverCode']['CustomerCode'] : null, Validators.required),
                CustomerName: new FormControl(carData['ThirdPartyDriverCode']['CustomerName'] ? carData['ThirdPartyDriverCode']['CustomerName'] : null, Validators.required),
            }),
            ThirdPartyInvoiceCode: new FormGroup({
                CustomerId: new FormControl(carData['ThirdPartyInvoiceCode']['CustomerId'] ? carData['ThirdPartyInvoiceCode']['CustomerId'] : null, Validators.required),
                CustomerCode: new FormControl(carData['ThirdPartyInvoiceCode']['CustomerCode'] ? carData['ThirdPartyInvoiceCode']['CustomerCode'] : null, Validators.required),
                CustomerName: new FormControl(carData['ThirdPartyInvoiceCode']['CustomerName'] ? carData['ThirdPartyInvoiceCode']['CustomerName'] : null, Validators.required),
            }),

            CustomerPrescriber: new FormGroup({
                CustomerId: new FormControl(carData['CustomerPrescriber']['CustomerId'] ? carData['CustomerPrescriber']['CustomerId'] : null),
                CustomerCode: new FormControl(carData['CustomerPrescriber']['CustomerCode'] ? carData['CustomerPrescriber']['CustomerCode'] : null),
                CustomerName: new FormControl(carData['CustomerPrescriber']['CustomerName'] ? carData['CustomerPrescriber']['CustomerName'] : null),
            }),

            CustomerKeeper: new FormGroup({
                CustomerId: new FormControl(carData['CustomerKeeper']['CustomerId'] ? carData['CustomerKeeper']['CustomerId'] : null),
                CustomerCode: new FormControl(carData['CustomerKeeper']['CustomerCode'] ? carData['CustomerKeeper']['CustomerCode'] : null),
                CustomerName: new FormControl(carData['CustomerKeeper']['CustomerName'] ? carData['CustomerKeeper']['CustomerName'] : null),
            }),

            VendorName: new FormControl({ value: carData['VendorName'] ? carData['VendorName'] : null, disabled: this.deshabilitarCampos }),
            Vendor: new FormControl({ value: carData['Vendor'] ? carData['Vendor'] : null, disabled: this.deshabilitarCampos }),
            GuaranteeDate: new FormControl({ value: carData['GuaranteeDate'] ? carData['GuaranteeDate'] : null, disabled: this.deshabilitarCampos }),
            EndBrandGuaranteeDate: new FormControl({ value: carData['EndBrandGuaranteeDate'] ? carData['EndBrandGuaranteeDate'] : null, disabled: this.deshabilitarCampos }),
            EndVendorGuaranteeDate: new FormControl({ value: carData['EndVendorGuaranteeDate'] ? carData['EndVendorGuaranteeDate'] : null, disabled: this.deshabilitarCampos }),
            EndPlusGuaranteeDate: new FormControl({ value: carData['EndPlusGuaranteeDate'] ? carData['EndPlusGuaranteeDate'] : null, disabled: this.deshabilitarCampos }),

            SaleDate: new FormControl({ value: carData['SaleDate'] ? carData['SaleDate'] : null, disabled: this.deshabilitarCampos }),
            MatriculationDate: new FormControl({ value: carData['MatriculationDate'] ? carData['MatriculationDate'] : null, disabled: this.deshabilitarCampos }),
            GuaranteeDuration: new FormControl({ value: carData['GuaranteeDuration'] ? carData['GuaranteeDuration'] : 0, disabled: this.deshabilitarCampos }),
            GuaranteeType: new FormControl({ value: carData['GuaranteeType'] ? carData['GuaranteeType'] : null, disabled: this.deshabilitarCampos}),
            LastMatriculationDate: new FormControl({ value: carData['LastMatriculationDate'] ? carData['LastMatriculationDate'] : null, disabled: this.deshabilitarCampos }),
            VehicleInspectionDate: new FormControl({ value: carData['VehicleInspectionDate'] ? carData['VehicleInspectionDate'] : null, disabled: this.deshabilitarCampos }),

            //sEGURIDAD



        });


        this.deshabilitandoCampos();

        this.vehiculoForm.get('ModelYear').valueChanges.subscribe((value: string) => {
            this.validateModelYear();
        });

        this.vehiculoForm.get('PlateNumber').valueChanges.subscribe((value: string) => {
            const auxValue = value.toUpperCase();
            this.vehiculoForm.get('PlateNumber').setValue(auxValue, { emitEvent: false });

            if (auxValue !== '') {
                this.isValidMatricula(auxValue);
                if (this.matriculaOk) {
                    this.isDuplicatePlate(auxValue);
                }
            } else {
                this.matriculaOk = true;
            }
        });

        this.vehiculoForm.get('Vin').valueChanges.subscribe((value: string) => {
            const auxValue = value.toUpperCase();
            this.vehiculoForm.get('Vin').setValue(auxValue, { emitEvent: false });
            if (value !== '') {
                this.isValidVin(auxValue);
                if (this.VinOk) {
                    this.isDuplicateVin(auxValue);
                }
            } else {
                this.VinOk = true;
            }
        });

        this.vehiculoForm.get('InternalVehicleUse').valueChanges.subscribe((value: any) => {
            this.internalUse = value;
        });

        this.vehiculoForm.get('Brand').valueChanges.subscribe((value: any) => {
            this.BrandCode = value;
            this.comprobarBrandCode();

        });

        this.comprobarBrandCode();

        this.vehiculoForm.get('LastInvoiceAmount').disable();
        this.isLoadingGestion = false;

        if (this.vehiculoForm.get('PlateNumber').value.length > 0 || this.vehiculoForm.get('Vin').value.length > 0) {
            this.comprobarErroresMatriculaVIn();
        }

        this.vehiculoForm.valueChanges.subscribe(val => {
            this.saveDataForm();
        });
        this.saveDataForm();

    }

    crearFormularioVacio() {

        this.formMode = this._authService.getUserRole();

        if (this.formMode) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = this.isModal ? true : false;
        }
        const BrandComplete = {
            BrandCode: '',
            CLIENTCODE: this._authService.getClientCode(),
            COMPANYCODE: this._authService.getCompanyCode(),
            Company: null,
            Description: ''
        };
        if (this.filial === 'ER' || this.filial === 'AC') {
            this.BrandCode = 'CIT';
            BrandComplete.Description = 'CITROËN';
        } else if (this.filial === 'AP') {
            this.BrandCode = 'PEU';
            BrandComplete.Description = 'PEUGEOT';
        } else {
            this.BrandCode = 'CIT';
            BrandComplete.Description = 'CITROËN';
        }
        BrandComplete.BrandCode = this.BrandCode;
        this.VehicleBrand = BrandComplete;

        this.mostrarLupas = true;
        const auxEnginePower = 'L';
        let auxGuaranteeCode = '***';
        if (this.carData.GuaranteeExtCode) {
            auxGuaranteeCode = this.carData.GuaranteeExtCode;
        } else {
            auxGuaranteeCode = '***';
        }
        let internalVehicleUse = '';
        if (this.transmitter === 'gestionVehiculosCortesia') {
            internalVehicleUse = 'VC';
        } else if (this.transmitter === 'stockVO') {
            internalVehicleUse = 'VO';
        }

        this.vehiculoForm = new FormGroup({
            registrarionSource: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            sfVehicleId: new FormControl({ value: null, disabled: this.deshabilitarCampos }),

            PlateNumber: new FormControl({ value: '', disabled: this.deshabilitarCampos }, Validators.required),
            Vin: new FormControl({ value: '', disabled: this.deshabilitarCampos }, Validators.required),

            Brand: new FormControl({ value: this.VehicleBrand, disabled: this.deshabilitarCampos }),
            BrandCode: new FormControl({ value: this.VehicleBrand.BrandCode, disabled: this.deshabilitarCampos }),

            GuaranteeExtCode: new FormControl({ value: auxGuaranteeCode, disabled: this.deshabilitarCampos }),
            EnginePower: new FormControl({ value: auxEnginePower, disabled: this.deshabilitarCampos }),
            Type: new FormControl({ value: 'T', disabled: this.deshabilitarCampos }),
            ModelCode: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            ModelYear: new FormControl({ value: null, disabled: this.deshabilitarCampos }, [Validators.required, modelYearValidator()]),
            VehicleModification: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            LastInvoiceAmount: new FormControl({ value: 0, disabled: this.deshabilitarCampos }),
            OpbCode: new FormControl({ value: '', disabled: true }),
            Opb: new FormControl({ value: { OpbCode: '', Description: '' }, disabled: this.deshabilitarCampos }),

            LastRepairDate: new FormControl({ value: null, disabled: true }),
            NextVisitDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),

            InternalVehicleUse: new FormControl(internalVehicleUse),
            OrganizationNumber: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            Description: new FormControl({ value: '', disabled: this.deshabilitarCampos }, Validators.required),
            Comment: new FormControl({ value: '', disabled: this.deshabilitarCampos }),

            KM: new FormControl({ value: '', disabled: this.deshabilitarCampos }, this.recepcionVO ? Validators.required : null),
            ThirdParty: new FormGroup({
                CustomerId: new FormControl(''),
                CustomerCode: new FormControl('', !this.recepcionVO ? Validators.required : null),
                CustomerName: new FormControl('', !this.recepcionVO ? Validators.required : null),
            }),
            ThirdPartyDriverCode: new FormGroup({
                CustomerId: new FormControl(''),
                CustomerCode: new FormControl('', !this.recepcionVO ? Validators.required : null),
                CustomerName: new FormControl('', !this.recepcionVO ? Validators.required : null),
            }),
            ThirdPartyInvoiceCode: new FormGroup({
                CustomerId: new FormControl(''),
                CustomerCode: new FormControl('', !this.recepcionVO ? Validators.required : null),
                CustomerName: new FormControl('', !this.recepcionVO ? Validators.required : null),
            }),

            CustomerPrescriber: new FormGroup({
                CustomerId: new FormControl(''),
                CustomerCode: new FormControl(''),
                CustomerName: new FormControl(''),
            }),

            CustomerKeeper: new FormGroup({
                CustomerId: new FormControl(''),
                CustomerCode: new FormControl(''),
                CustomerName: new FormControl(''),
            }),
            // GARANTIA
            Vendor: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            VendorName: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            GuaranteeDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            EndBrandGuaranteeDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            EndVendorGuaranteeDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            EndPlusGuaranteeDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            SaleDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            MatriculationDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            LastMatriculationDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            VehicleInspectionDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),

        });

        this.deshabilitandoCampos();

        this.vehiculoForm.get('ModelYear').valueChanges.subscribe((value: string) => {
            this.validateModelYear();
        });

        this.vehiculoForm.get('PlateNumber').valueChanges.subscribe((value: string) => {
            const auxValue = value.toUpperCase();
            this.vehiculoForm.get('PlateNumber').setValue(auxValue, { emitEvent: false });

            if (auxValue !== '') {
                this.isValidMatricula(auxValue);
                if (this.matriculaOk) {
                    this.isDuplicatePlate(auxValue);
                }
            } else {
                this.matriculaOk = true;
            }
        });

        this.vehiculoForm.get('Vin').valueChanges.subscribe((value: string) => {
            const auxValue = value.toUpperCase();
            this.vehiculoForm.get('Vin').setValue(auxValue, { emitEvent: false });
            if (value !== '') {
                this.isValidVin(auxValue);
                if (this.VinOk) {
                    this.isDuplicateVin(auxValue);
                }
            } else {
                this.VinOk = true;
            }
        });


        this.vehiculoForm.get('BrandCode').valueChanges.subscribe((value: any) => {
            this.BrandCode = value;
            this.comprobarBrandCode();
        });
        this.comprobarBrandCode();

        this.vehiculoForm.get('LastInvoiceAmount').disable();

        this.isLoadingGestion = false;

        this.vehiculoForm.valueChanges.subscribe(val => {
            this.saveDataForm();
        });
        this.saveDataForm();
    }

    formularioDesdeTerceros(datosCustomer) {
        const BrandComplete = {
            BrandCode: '',
            CLIENTCODE: this._authService.getClientCode(),
            COMPANYCODE: this._authService.getCompanyCode(),
            Company: null,
            Description: ''
        };
        if (this.filial === 'ER' || this.filial === 'AC') {
            this.BrandCode = 'CIT';
            BrandComplete.Description = 'CITROËN';
        } else if (this.filial === 'AP') {
            this.BrandCode = 'PEU';
            BrandComplete.Description = 'PEUGEOT';
        } else {
            this.BrandCode = 'CIT';
            BrandComplete.Description = 'CITROËN';
        }
        BrandComplete.BrandCode = this.BrandCode;
        this.VehicleBrand = BrandComplete;


        this.mostrarLupas = true;
        const auxEnginePower = 'L';
        let auxGuaranteeCode = '***';
        if (this.carData.GuaranteeExtCode) {
            auxGuaranteeCode = this.carData.GuaranteeExtCode;
        } else {
            auxGuaranteeCode = '***';
        }
        let internalVehicleUse = 'NI';
        if (this.carData.InternalVehicleUse) {
            internalVehicleUse = this.carData.InternalVehicleUse;
        } else if (this.transmitter === 'gestionVehiculosCortesia') {
            internalVehicleUse = 'VC';
        } else if (this.transmitter === 'stockVO') {
            internalVehicleUse = 'VO';
        }
        this.vehiculoForm = new FormGroup({
            registrarionSource: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            sfVehicleId: new FormControl({ value: null, disabled: this.deshabilitarCampos }),

            PlateNumber: new FormControl({ value: '', disabled: this.deshabilitarCampos }, Validators.required),
            Vin: new FormControl({ value: '', disabled: this.deshabilitarCampos }, Validators.required),

            Brand: new FormControl({ value: this.VehicleBrand, disabled: this.deshabilitarCampos }),
            BrandCode: new FormControl({ value: this.VehicleBrand.BrandCode, disabled: this.deshabilitarCampos }),

            GuaranteeExtCode: new FormControl({ value: auxGuaranteeCode, disabled: this.deshabilitarCampos }),

            EnginePower: new FormControl({ value: auxEnginePower, disabled: this.deshabilitarCampos }),
            Type: new FormControl({ value: 'T', disabled: this.deshabilitarCampos }),
            ModelCode: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            ModelYear: new FormControl({ value: null, disabled: this.deshabilitarCampos }, [Validators.required, modelYearValidator()]),
            VehicleModification: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            LastInvoiceAmount: new FormControl({ value: 0, disabled: this.deshabilitarCampos }),
            OpbCode: new FormControl({ value: '', disabled: true }),
            Opb: new FormControl({ value: { OpbCode: '', Description: '' }, disabled: this.deshabilitarCampos }),

            LastRepairDate: new FormControl({ value: null, disabled: true }),
            NextVisitDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),

            InternalVehicleUse: new FormControl(internalVehicleUse),
            OrganizationNumber: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            Description: new FormControl({ value: '', disabled: this.deshabilitarCampos }, Validators.required),
            KM: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            Comment: new FormControl({ value: '', disabled: this.deshabilitarCampos }),

            ThirdParty: new FormGroup({
                CustomerId: new FormControl(datosCustomer.CustomerId),
                CustomerCode: new FormControl(datosCustomer.CustomerCode, Validators.required),
                CustomerName: new FormControl(datosCustomer.CustomerName, Validators.required),
            }),
            ThirdPartyDriverCode: new FormGroup({
                CustomerId: new FormControl(datosCustomer.CustomerId),
                CustomerCode: new FormControl(datosCustomer.CustomerCode, Validators.required),
                CustomerName: new FormControl(datosCustomer.CustomerName, Validators.required),
            }),
            ThirdPartyInvoiceCode: new FormGroup({
                CustomerId: new FormControl(datosCustomer.CustomerId),
                CustomerCode: new FormControl(datosCustomer.CustomerCode, Validators.required),
                CustomerName: new FormControl(datosCustomer.CustomerName, Validators.required),
            }),

            CustomerPrescriber: new FormGroup({
                CustomerId: new FormControl(''),
                CustomerCode: new FormControl(''),
                CustomerName: new FormControl(''),
            }),

            CustomerKeeper: new FormGroup({
                CustomerId: new FormControl(''),
                CustomerCode: new FormControl(''),
                CustomerName: new FormControl(''),
            }),


            Vendor: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            VendorName: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            GuaranteeDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            EndBrandGuaranteeDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            EndVendorGuaranteeDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            EndPlusGuaranteeDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),

            SaleDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            MatriculationDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            LastMatriculationDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            VehicleInspectionDate: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
        });

        this.deshabilitandoCampos();

        this.vehiculoForm.get('ModelYear').valueChanges.subscribe((value: string) => {
            this.validateModelYear();
        });

        this.vehiculoForm.get('PlateNumber').valueChanges.subscribe((value: string) => {
            const auxValue = value.toUpperCase();
            this.vehiculoForm.get('PlateNumber').setValue(auxValue, { emitEvent: false });

            if (auxValue !== '') {
                this.isValidMatricula(auxValue);
                if (this.matriculaOk) {
                    this.isDuplicatePlate(auxValue);
                }
            } else {
                this.matriculaOk = true;
            }
        });

        this.vehiculoForm.get('Vin').valueChanges.subscribe((value: string) => {
            const auxValue = value.toUpperCase();
            this.vehiculoForm.get('Vin').setValue(auxValue, { emitEvent: false });
            if (value !== '') {
                this.isValidVin(auxValue);
                if (this.VinOk) {
                    this.isDuplicateVin(auxValue);
                }
            } else {
                this.VinOk = true;
            }
        });

        this.vehiculoForm.get('BrandCode').valueChanges.subscribe((value: any) => {
            this.BrandCode = value;
            this.comprobarBrandCode();
        });
        this.comprobarBrandCode();
        this.vehiculoForm.get('LastInvoiceAmount').disable();
        const datosForm = this.vehiculoForm.getRawValue();
        this.comprobarPestana();
        this.isLoadingGestion = false;

    }

    loadDataForm() {
        this.statusFormSend = 'edit';
        this.formMode = this._authService.getUserRole();

        const auxCustomerPrescriber = {
            CustomerId: '',
            CustomerCode: '',
            CustomerName: ''
        };
        if (this.carData && this.carData.CustomerPrescriber) {
            const Prescriber = this.carData['CustomerPrescriber'];
            auxCustomerPrescriber.CustomerId = Prescriber.CustomerId;
            auxCustomerPrescriber.CustomerCode = Prescriber.CustomerCode;
            auxCustomerPrescriber.CustomerName = Prescriber.CustomerName;
        }
        const auxCustomerKeeper = {
            CustomerId: '',
            CustomerCode: '',
            CustomerName: ''
        };
        if (this.carData && this.carData.CustomerKeeper) {
            const Keeper = this.carData['CustomerKeeper'];
            auxCustomerKeeper.CustomerId = Keeper.CustomerId;
            auxCustomerKeeper.CustomerCode = Keeper.CustomerCode;
            auxCustomerKeeper.CustomerName = Keeper.CustomerName;
        }
        // De momento solo tengo en cuenta el modo consulta y dejo de para mas adelante el modoEdicion || !this.modoEdicion
        if (this.formMode) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = this.isModal ? true : false;
        }

        let auxEnginePower = 'L';
        if (this.carData && this.carData.EnginePower) {
            auxEnginePower = this.carData.EnginePower;
        } else {
            auxEnginePower = 'L';
        }
        let auxGuaranteeCode = '***';
        if (this.carData && this.carData.GuaranteeExtCode) {
            auxGuaranteeCode = this.carData.GuaranteeExtCode;
        } else {
            auxGuaranteeCode = '***';
        }
        this.primerCampo = {
            Description: this.seleccionar,
            Value: 0
        };

        const BrandComplete = {
            BrandCode: 'CIT',
            CLIENTCODE: this._authService.getClientCode(),
            COMPANYCODE: this._authService.getCompanyCode(),
            Company: null,
            Description: 'CITROËN'
        };

        if (this.VehicleBrand && this.VehicleBrand.BrandCode) {
            this.BrandCode = this.VehicleBrand.BrandCode;
        } else {
            if (this.filial === 'ER' || this.filial === 'AC') {
                this.BrandCode = 'CIT';
            } else if (this.filial === 'AP') {
                this.BrandCode = 'PEU';
            } else {
                this.BrandCode = 'CIT';
            }
        }
        let Opb = { OpbCode: '', Description: '' };

        if (this.BrandCode === 'PEU' && this.filial === 'AP') {
            if (this.carData['OpbCode']) {
                this.cargarPeugeot(this.carData['OpbCode'], true);
            }
        } else if (this.carData && this.carData.VehicleModelGarageCitroen) {
            const VehicleModelGarageCitroen = this.carData.VehicleModelGarageCitroen;
            Opb = {
                OpbCode: VehicleModelGarageCitroen.OpbCode,
                Description: VehicleModelGarageCitroen.Description
            };
        } else {
            Opb = { OpbCode: '', Description: '' };
        }

        if (this.filial === 'OV') {
            this.isESAEnabled();
        }

        let internalVehicleUse = 'NI';
        if (this.carData.InternalVehicleUse) {
            internalVehicleUse = this.carData.InternalVehicleUse;
        } else if (this.transmitter === 'gestionVehiculosCortesia') {
            internalVehicleUse = 'VC';
        } else if (this.transmitter === 'stockVO') {
            internalVehicleUse = 'VO';
        }

        this.vehiculoForm = new FormGroup({

            registrarionSource: new FormControl({ value: this.carData['registrarionSource'] ? this.carData['registrarionSource'] : 'DMS', disabled: this.deshabilitarCampos }),
            sfVehicleId: new FormControl({ value: this.carData['sfVehicleId'] ? this.carData['sfVehicleId'] : null, disabled: this.deshabilitarCampos }),

            PlateNumber: new FormControl({ value: this.carData['PlateNumber'] ? this.carData['PlateNumber'] : '', disabled: this.deshabilitarCampos }, Validators.required),
            Vin: new FormControl({ value: this.carData['Vin'] ? this.carData['Vin'] : '', disabled: this.deshabilitarCampos }, Validators.required),

            Brand: new FormControl({ value: this.VehicleBrand ? this.VehicleBrand : BrandComplete, disabled: this.deshabilitarCampos }),

            BrandCode: new FormControl({ value: this.BrandCode, disabled: this.deshabilitarCampos }),

            GuaranteeExtCode: new FormControl({ value: auxGuaranteeCode, disabled: this.deshabilitarCampos }),
            EnginePower: new FormControl({ value: auxEnginePower, disabled: this.deshabilitarCampos }),
            Type: new FormControl({ value: this.carData['Type'] ? this.carData['Type'] : 'T', disabled: this.deshabilitarCampos }),

            ModelCode: new FormControl({ value: this.carData['ModelCode'] ? this.carData['ModelCode'] : '', disabled: this.deshabilitarCampos }),
            ModelYear: new FormControl({ value: this.carData['ModelYear'] ? this.carData['ModelYear'] : null, disabled: this.deshabilitarCampos }, [Validators.required, modelYearValidator()]),
            VehicleModification: new FormControl({ value: this.carData['VehicleModification'] ? this.carData['VehicleModification'] : '', disabled: this.deshabilitarCampos }),
            LastInvoiceAmount: new FormControl({ value: this.carData['LastInvoiceAmount'] ? this.carData['LastInvoiceAmount'] : 0, disabled: this.deshabilitarCampos }),

            OpbCode: new FormControl({ value: this.carData['OpbCode'] ? this.carData['OpbCode'] : '', disabled: true }),
            Opb: new FormControl({ value: Opb, disabled: this.deshabilitarCampos }), // descipcion

            LastRepairDate: new FormControl({ value: this.carData['LastRepairDate'] ? this._globals.getDateFormat(this.carData['LastRepairDate']) : null, disabled: true }),
            NextVisitDate: new FormControl({ value: this.carData['NextVisitDate'] ? this._globals.getDateFormat(this.carData['NextVisitDate']) : null, disabled: this.deshabilitarCampos }),

            InternalVehicleUse: new FormControl(internalVehicleUse),
            OrganizationNumber: new FormControl({ value: this.carData['OrganizationNumber'] ? this.carData['OrganizationNumber'] : '', disabled: this.deshabilitarCampos }),
            Description: new FormControl({ value: this.carData['Description'] ? this.carData['Description'] : '', disabled: this.deshabilitarCampos }, Validators.required),
            KM: new FormControl({ value: this.carData['KM'] ? this.carData['KM'] : '', disabled: this.deshabilitarCampos }),
            Comment: new FormControl({ value: this.carData['Comment'] ? this.carData['Comment'] : '', disabled: this.deshabilitarCampos }),

            ThirdParty: new FormGroup({
                CustomerId: new FormControl(this.carData && this.carData.ThirdParty ? this.carData['ThirdParty']['CustomerId'] : null, Validators.required),
                CustomerCode: new FormControl(this.carData && this.carData.ThirdParty ? this.carData['ThirdParty']['CustomerCode'] : null, Validators.required),
                CustomerName: new FormControl(this.carData && this.carData.ThirdParty ? this.carData['ThirdParty']['CustomerName'] : null, Validators.required),
            }),
            ThirdPartyDriverCode: new FormGroup({
                CustomerId: new FormControl(this.carData && this.carData.ThirdPartyDriverCode ? this.carData['ThirdPartyDriverCode']['CustomerId'] : null, Validators.required),
                CustomerCode: new FormControl(this.carData && this.carData.ThirdPartyDriverCode ? this.carData['ThirdPartyDriverCode']['CustomerCode'] : null, Validators.required),
                CustomerName: new FormControl(this.carData && this.carData.ThirdPartyDriverCode ? this.carData['ThirdPartyDriverCode']['CustomerName'] : null, Validators.required),
            }),
            ThirdPartyInvoiceCode: new FormGroup({
                CustomerId: new FormControl(this.carData && this.carData.ThirdPartyInvoiceCode ? this.carData['ThirdPartyInvoiceCode']['CustomerId'] : null, Validators.required),
                CustomerCode: new FormControl(this.carData && this.carData.ThirdPartyInvoiceCode ? this.carData['ThirdPartyInvoiceCode']['CustomerCode'] : null, Validators.required),
                CustomerName: new FormControl(this.carData && this.carData.ThirdPartyInvoiceCode ? this.carData['ThirdPartyInvoiceCode']['CustomerName'] : null, Validators.required),
            }),

            CustomerPrescriber: new FormGroup({
                CustomerId: new FormControl(auxCustomerPrescriber.CustomerId),
                CustomerCode: new FormControl(auxCustomerPrescriber.CustomerCode),
                CustomerName: new FormControl(auxCustomerPrescriber.CustomerName),
            }),

            CustomerKeeper: new FormGroup({
                CustomerId: new FormControl(auxCustomerKeeper.CustomerId),
                CustomerCode: new FormControl(auxCustomerKeeper.CustomerCode),
                CustomerName: new FormControl(auxCustomerKeeper.CustomerName),
            }),

            VendorName: new FormControl({ value: this.carData['Vendor'] ? this.carData['Vendor']['Name'] : null, disabled: this.deshabilitarCampos }),

            Vendor: new FormControl({ value: this.carData['Vendor'] ? this.carData['Vendor']['VENDORCODE'] : null, disabled: this.deshabilitarCampos }),

            GuaranteeDate: new FormControl({ value: this.carData['GuaranteeDate'] ? this._globals.getDateFormat(this.carData['GuaranteeDate']) : null, disabled: this.deshabilitarCampos }), //, [Validators.pattern(this.unamePattern)]
            EndBrandGuaranteeDate: new FormControl({ value: this.carData['EndBrandGuaranteeDate'] ? this._globals.getDateFormat(this.carData['EndBrandGuaranteeDate']) : null, disabled: this.deshabilitarCampos }),
            EndVendorGuaranteeDate: new FormControl({ value: this.carData['EndVendorGuaranteeDate'] ? this._globals.getDateFormat(this.carData['EndVendorGuaranteeDate']) : null, disabled: this.deshabilitarCampos }),
            EndPlusGuaranteeDate: new FormControl({ value: this.carData['EndPlusGuaranteeDate'] ? this._globals.getDateFormat(this.carData['EndPlusGuaranteeDate']) : null, disabled: this.deshabilitarCampos }),

            SaleDate: new FormControl({ value: this.carData['SaleDate'] ? this._globals.getDateFormat(this.carData['SaleDate']) : null, disabled: this.deshabilitarCampos }),
            MatriculationDate: new FormControl({ value: this.carData['MatriculationDate'] ? this._globals.getDateFormat(this.carData['MatriculationDate']) : null, disabled: this.deshabilitarCampos }),
            GuaranteeDuration: new FormControl({ value: this.carData['GuaranteeDuration'] ? this.carData['GuaranteeDuration'] : 0, disabled: this.deshabilitarCampos}),
            GuaranteeType: new FormControl({ value: this.carData['GuaranteeType'] ? this.carData['GuaranteeType'] : null, disabled: this.deshabilitarCampos}),
            LastMatriculationDate: new FormControl({ value: this.carData['LastMatriculationDate'] ? this._globals.getDateFormat(this.carData['LastMatriculationDate']) : null, disabled: this.deshabilitarCampos }),
            VehicleInspectionDate: new FormControl({ value: this.carData['VehicleInspectionDate'] ? this._globals.getDateFormat(this.carData['VehicleInspectionDate']) : null, disabled: this.deshabilitarCampos }),
        });

        this.deshabilitandoCampos();

        this.vehiculoForm.get('ModelYear').valueChanges.subscribe((value: string) => {
            this.validateModelYear();
        });

        this.vehiculoForm.get('PlateNumber').valueChanges.subscribe((value: string) => {
            const auxValue = value.toUpperCase();
            this.vehiculoForm.get('PlateNumber').setValue(auxValue, { emitEvent: false });

            if (auxValue !== '') {
                this.isValidMatricula(auxValue);
                if (this.matriculaOk) {
                    this.isDuplicatePlate(auxValue);
                }
            } else {
                this.matriculaOk = true;
            }
        });

        this.vehiculoForm.get('Vin').valueChanges.subscribe((value: string) => {
            const auxValue = value.toUpperCase();
            this.vehiculoForm.get('Vin').setValue(auxValue, { emitEvent: false });
            if (value !== '') {
                this.isValidVin(auxValue);
                if (this.VinOk) {
                    this.isDuplicateVin(auxValue);
                }
            } else {
                this.VinOk = true;
            }
        });

        this.vehiculoForm.get('InternalVehicleUse').valueChanges.subscribe((value: any) => {
            this.internalUse = value;
        });

        this.vehiculoForm.get('BrandCode').valueChanges.subscribe((value: any) => {
            this.BrandCode = value;
            this.comprobarBrandCode();
        });

        this.comprobarBrandCode();

        this.vehiculoForm.get('LastInvoiceAmount').disable();
        this.isLoadingGestion = false;
        this.comprobarErroresMatriculaVIn();

        this.vehiculoForm.valueChanges.subscribe(val => {
            this.saveDataForm();
        });

        this.saveDataForm();
        const auxForm = this.vehiculoForm.getRawValue();
    }

    changeState(event) {
    }
    isESAEnabled() {
        const _URL_ = `Services/Workshop/EsaService.svc/GetAvailability`;

        this._gestionTercerosService.checkEsa().subscribe((resp: any) => {
            this.hasESA = resp.AvailabilityState === 'OK';
        });
    }

    crearFormularioGestion() {
        this.gestion = new FormGroup({

            vehiculoStatus: new FormControl({ value: this.carData['VehicleState'] ? this.carData['VehicleState'] : 0, disabled: this.deshabilitarCampos }),
            ubicacion: new FormControl({ value: this.carData['VOLocationCode'] ? this.carData['VOLocationCode'] : 99, disabled: this.deshabilitarCampos }),

            numeroStock: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            fechaEntradaStock: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            fechaSalidaStock: new FormControl({ value: null, disabled: this.deshabilitarCampos }),
            gastosPuestaApunto: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            precioCompra: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            ORasociadas: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            costeOR: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            gastosAdecuacion: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            totalFicheros: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            CosteOR: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            precioVenta: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
            margen: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
        });
        this.gestion.valueChanges.subscribe(val => {
            this.saveDataFormGestion();
        });
        this.saveDataFormGestion();
    }

    crearFormularioCaractVehic() {
        this.caractVehic = new FormGroup({
            Seats: new FormControl({ value: this.carData && this.carData.Seats ? this.carData.Seats : 0, disabled: this.deshabilitarCampos }),
            BodyWork: new FormControl({ value: this.carData && this.carData.BodyWork ? this.carData.BodyWork : '', disabled: this.deshabilitarCampos }),
            ExteriorColor: new FormControl({ value: this.carData && this.carData.ExteriorColor ? this.carData.ExteriorColor : '', disabled: this.deshabilitarCampos }),
            InteriorColor: new FormControl({ value: this.carData && this.carData.InteriorColor ? this.carData.InteriorColor : '', disabled: this.deshabilitarCampos }),
            FiscalPower: new FormControl({ value: this.carData && this.carData.FiscalPower ? this.carData.FiscalPower : 0, disabled: this.deshabilitarCampos }),
            Speed: new FormControl({ value:  this.carData && this.carData.Speed ? this.carData.Speed : 0, disabled: this.deshabilitarCampos }),
        })
        this.caractVehic.valueChanges.subscribe(val => {
            this.saveDataFormCaractVehic();
        });
        this.saveDataFormCaractVehic();
    }

    crearFormularioCompraVehic() {
        this.compraVehic = new FormGroup({
            VehicleCompanyCode: new FormControl({ value: this.carData && this.carData.VehicleCompanyCode ? this.carData.VehicleCompanyCode : '', disabled: this.deshabilitarCampos }),
            VehicleCompanyName: new FormControl({ value: this.carData && this.carData.VehicleCompanyName ? this.carData.VehicleCompanyName : '', disabled: this.deshabilitarCampos }),
            SiteCode: new FormControl({ value: this.carData && this.carData.SiteCode ? this.carData.SiteCode : 0, disabled: this.deshabilitarCampos }),
            SiteLabel: new FormControl({ value: this.carData && this.carData.SiteLabel ? this.carData.SiteLabel : '', disabled: this.deshabilitarCampos }),
            LocationCode: new FormControl({ value: this.carData && this.carData.LocationCode ? this.carData.LocationCode : '', disabled: this.deshabilitarCampos }),
            LocationDescription: new FormControl({ value: this.carData && this.carData.LocationDescription ? this.carData.LocationDescription : '', disabled: this.deshabilitarCampos }),
            SaleBuyerCode: new FormControl({ value: this.carData && this.carData.SaleBuyerCode ? this.carData.SaleBuyerCode : '', disabled: this.deshabilitarCampos }),
            SaleBuyerName: new FormControl({ value: this.carData && this.carData.SaleBuyerName ? this.carData.SaleBuyerName : '', disabled: this.deshabilitarCampos }),
            VOSupplierCustomerName: new FormControl({ value: this.carData && this.carData.VOSupplierCustomerName ? this.carData.VOSupplierCustomerName : '', disabled: this.deshabilitarCampos }),
        })
        this.compraVehic.valueChanges.subscribe(val => {
            this.saveDataFormCompraVehic();
        });
        this.saveDataFormCompraVehic();
    }

    crearFormularioCarroceria() {
        this.carroceria = new FormGroup({
            trasera: new FormControl({ value: this.searchValor(18), disabled: this.deshabilitarCampos }),
            maletero: new FormControl({ value: this.searchValor(17), disabled: this.deshabilitarCampos }),
            rtraseraIzq: new FormControl({ value: this.searchValor(15), disabled: this.deshabilitarCampos }),
            rTraseraDch: new FormControl({ value: this.searchValor(14), disabled: this.deshabilitarCampos }),
            aletaTrasIzq: new FormControl({ value: this.searchValor(20), disabled: this.deshabilitarCampos }),
            aletaTrasDch: new FormControl({ value: this.searchValor(19), disabled: this.deshabilitarCampos }),
            lunaTrasera: new FormControl({ value: this.searchValor(16), disabled: this.deshabilitarCampos }),
            puertaTrasIzq: new FormControl({ value: this.searchValor(12), disabled: this.deshabilitarCampos }),
            puertatrasDer: new FormControl({ value: this.searchValor(11), disabled: this.deshabilitarCampos }),
            faldonIzq: new FormControl({ value: this.searchValor(10), disabled: this.deshabilitarCampos }),
            faldonDer: new FormControl({ value: this.searchValor(9), disabled: this.deshabilitarCampos }),
            puertaDelIzq: new FormControl({ value: this.searchValor(8), disabled: this.deshabilitarCampos }),
            puertaDelDer: new FormControl({ value: this.searchValor(7), disabled: this.deshabilitarCampos }),
            techo: new FormControl({ value: this.searchValor(13), disabled: this.deshabilitarCampos }),
            ruedaDelIzq: new FormControl({ value: this.searchValor(3), disabled: this.deshabilitarCampos }),
            ruedaDelDer: new FormControl({ value: this.searchValor(4), disabled: this.deshabilitarCampos }),
            lunaDelantera: new FormControl({ value: this.searchValor(6), disabled: this.deshabilitarCampos }),
            capo: new FormControl({ value: this.searchValor(1), disabled: this.deshabilitarCampos }),
            frontal: new FormControl({ value: this.searchValor(0), disabled: this.deshabilitarCampos }),
            aletaDelIzq: new FormControl({ value: this.searchValor(8), disabled: this.deshabilitarCampos }),
            aletaDelDer: new FormControl({ value: this.searchValor(7), disabled: this.deshabilitarCampos }),
        });

        this.carroceria.valueChanges.subscribe(val => {
            this.saveDataFormCarroceria();
        });

        this.saveDataFormCarroceria();
    }
    crearFormularioCarroceriaRecuperado(carroceria) {
        this.carroceria = new FormGroup({
            trasera: new FormControl({ value: carroceria.trasera ? carroceria.trasera : 0, disabled: this.deshabilitarCampos }),
            maletero: new FormControl({ value: carroceria.maletero ? carroceria.maletero : 0, disabled: this.deshabilitarCampos }),
            rtraseraIzq: new FormControl({ value: carroceria.rtraseraIzq ? carroceria.rtraseraIzq : 0, disabled: this.deshabilitarCampos }),
            rTraseraDch: new FormControl({ value: carroceria.rTraseraDch ? carroceria.rTraseraDch : 0, disabled: this.deshabilitarCampos }),
            aletaTrasIzq: new FormControl({ value: carroceria.aletaTrasIzq ? carroceria.aletaTrasIzq : 0, disabled: this.deshabilitarCampos }),
            aletaTrasDch: new FormControl({ value: carroceria.aletaTrasDch ? carroceria.aletaTrasDch : 0, disabled: this.deshabilitarCampos }),
            lunaTrasera: new FormControl({ value: carroceria.lunaTrasera ? carroceria.lunaTrasera : 0, disabled: this.deshabilitarCampos }),
            puertaTrasIzq: new FormControl({ value: carroceria.puertaTrasIzq ? carroceria.puertaTrasIzq : 0, disabled: this.deshabilitarCampos }),
            puertatrasDer: new FormControl({ value: carroceria.puertatrasDer ? carroceria.puertatrasDer : 0, disabled: this.deshabilitarCampos }),
            faldonIzq: new FormControl({ value: carroceria.faldonIzq ? carroceria.faldonIzq : 0, disabled: this.deshabilitarCampos }),
            faldonDer: new FormControl({ value: carroceria.faldonDer ? carroceria.faldonDer : 0, disabled: this.deshabilitarCampos }),
            puertaDelIzq: new FormControl({ value: carroceria.puertaDelIzq ? carroceria.puertaDelIzq : 0, disabled: this.deshabilitarCampos }),
            puertaDelDer: new FormControl({ value: carroceria.puertaDelDer ? carroceria.puertaDelDer : 0, disabled: this.deshabilitarCampos }),
            techo: new FormControl({ value: carroceria.techo ? carroceria.techo : 0, disabled: this.deshabilitarCampos }),
            ruedaDelIzq: new FormControl({ value: carroceria.ruedaDelIzq ? carroceria.ruedaDelIzq : 0, disabled: this.deshabilitarCampos }),
            ruedaDelDer: new FormControl({ value: carroceria.ruedaDelDer ? carroceria.ruedaDelDer : 0, disabled: this.deshabilitarCampos }),
            lunaDelantera: new FormControl({ value: carroceria.lunaDelantera ? carroceria.lunaDelantera : 0, disabled: this.deshabilitarCampos }),
            capo: new FormControl({ value: carroceria.capo ? carroceria.capo : 0, disabled: this.deshabilitarCampos }),
            frontal: new FormControl({ value: carroceria.frontal ? carroceria.frontal : 0, disabled: this.deshabilitarCampos }),
            aletaDelIzq: new FormControl({ value: carroceria.aletaDelIzq ? carroceria.aletaDelIzq : 0, disabled: this.deshabilitarCampos }),
            aletaDelDer: new FormControl({ value: carroceria.aletaDelDer ? carroceria.aletaDelDer : 0, disabled: this.deshabilitarCampos }),
        });

        this.carroceria.valueChanges.subscribe(val => {
            this.saveDataFormCarroceria();
        });

        this.saveDataFormCarroceria();

        const datosForm = this.carroceria.getRawValue();
    }

    crearFormularioCaractVehicRecuperado(caractVehic){
        this.caractVehic = new FormGroup({
            Seats: new FormControl({ value: caractVehic.Seats ? caractVehic.Seats : 0, disabled: this.deshabilitarCampos }),
            BodyWork: new FormControl({ value: caractVehic.BodyWork ? caractVehic.BodyWork : '', disabled: this.deshabilitarCampos }),
            ExteriorColor: new FormControl({ value: caractVehic.ExteriorColor ? caractVehic.ExteriorColor : '', disabled: this.deshabilitarCampos }),
            InteriorColor: new FormControl({ value: caractVehic.InteriorColor ? caractVehic.InteriorColor : '', disabled: this.deshabilitarCampos }),
            FiscalPower: new FormControl({ value: caractVehic.FiscalPower ? caractVehic.FiscalPower : 0, disabled: this.deshabilitarCampos }),
            Speed: new FormControl({ value: caractVehic.Speed ? caractVehic.Speed : 0, disabled: this.deshabilitarCampos }),
        })
        this.caractVehic.valueChanges.subscribe(val => {
            this.saveDataFormCaractVehic();
        });
        this.saveDataFormCaractVehic();
    }

    crearFormularioCompraVehicRecuperado(compraVehic){
        this.compraVehic = new FormGroup({
            VehicleCompanyCode: new FormControl({ value: compraVehic.VehicleCompanyCode ? compraVehic.VehicleCompanyCode : '', disabled: this.deshabilitarCampos }),
            VehicleCompanyName: new FormControl({ value: compraVehic.VehicleCompanyName ? compraVehic.VehicleCompanyName :  '', disabled: this.deshabilitarCampos }),
            SiteCode: new FormControl({ value: compraVehic.SiteCode ? compraVehic.SiteCode :  0, disabled: this.deshabilitarCampos }),
            SiteLabel: new FormControl({ value: compraVehic.SiteLabel ? compraVehic.SiteLabel :  '', disabled: this.deshabilitarCampos }),
            LocationCode: new FormControl({ value: compraVehic.LocationCode ? compraVehic.LocationCode :  '', disabled: this.deshabilitarCampos }),
            LocationDescription: new FormControl({ value: compraVehic.LocationDescription ? compraVehic.LocationDescription :  '', disabled: this.deshabilitarCampos }),
            SaleBuyerCode: new FormControl({ value: compraVehic.SaleBuyerCode ? compraVehic.SaleBuyerCode :  '', disabled: this.deshabilitarCampos }),
            SaleBuyerName: new FormControl({ value: compraVehic.SaleBuyerName ? compraVehic.SaleBuyerName :  '', disabled: this.deshabilitarCampos }),
            VOSupplierCustomerName: new FormControl({ value: compraVehic.VOSupplierCustomerName ? compraVehic.VOSupplierCustomerName :  '', disabled: this.deshabilitarCampos }),
        })
        this.compraVehic.valueChanges.subscribe(val => {
            this.saveDataFormCompraVehic();
        });
        this.saveDataFormCompraVehic();
    }

    crearFormularioGestionRecuperado(gestion) {

        this.gestion = new FormGroup({
            vehiculoStatus: new FormControl({ value: gestion.vehiculoStatus ? gestion.vehiculoStatus : 0, disabled: this.deshabilitarCampos }),
            ubicacion: new FormControl({ value: gestion.ubicacion ? gestion.ubicacion : 99, disabled: this.deshabilitarCampos }),
            numeroStock: new FormControl({ value: gestion.numeroStock ? gestion.numeroStock : '', disabled: this.deshabilitarCampos }),
            fechaEntradaStock: new FormControl({ value: gestion.fechaEntradaStock ? gestion.fechaEntradaStock : null, disabled: this.deshabilitarCampos }),
            fechaSalidaStock: new FormControl({ value: gestion.fechaSalidaStock ? gestion.fechaSalidaStock : null, disabled: this.deshabilitarCampos }),
            gastosPuestaApunto: new FormControl({ value: gestion.gastosPuestaApunto ? gestion.gastosPuestaApunto : '', disabled: this.deshabilitarCampos }),
            precioCompra: new FormControl({ value: gestion.precioCompra ? gestion.precioCompra : '', disabled: this.deshabilitarCampos }),
            ORasociadas: new FormControl({ value: gestion.ORasociadas ? gestion.ORasociadas : '', disabled: this.deshabilitarCampos }),
            costeOR: new FormControl({ value: gestion.costeOR ? gestion.costeOR : '', disabled: this.deshabilitarCampos }),
            gastosAdecuacion: new FormControl({ value: gestion.gastosAdecuacion ? gestion.gastosAdecuacion : '', disabled: this.deshabilitarCampos }),
            totalFicheros: new FormControl({ value: gestion.totalFicheros ? gestion.totalFicheros : '', disabled: this.deshabilitarCampos }),
            CosteOR: new FormControl({ value: gestion.CosteOR ? gestion.CosteOR : '', disabled: this.deshabilitarCampos }),
            precioVenta: new FormControl({ value: gestion.precioVenta ? gestion.precioVenta : '', disabled: this.deshabilitarCampos }),
            margen: new FormControl({ value: gestion.margen ? gestion.margen : '', disabled: this.deshabilitarCampos }),
        });

        this.gestion.valueChanges.subscribe(val => {
            this.saveDataFormGestion();
        });
        this.saveDataFormGestion();
        const datosForm = this.gestion.getRawValue();
    }

    searchValor(num) {
        let auxPointState = 0;
        this.vehicleValuationDetailList.forEach(item => {
            if (item.PointID === num) {
                auxPointState = item.PointState;
            }
        });
        return auxPointState;
    }



    saveDataFormGestion() {
        const datosForm = this.gestion.getRawValue();
        const auxForm = {
            'form': datosForm
        };
        this._dataSaveService.setFormularioGestion(this.transmitter, auxForm);
    }

    saveDataFormCaractVehic() {
        const datosForm = this.caractVehic.getRawValue();
        const auxForm = {
            'form': datosForm
        };
        this._dataSaveService.setFormularioCaractVehic(this.transmitter, auxForm);
    }

    saveDataFormCompraVehic() {
        const datosForm = this.compraVehic.getRawValue();
        const auxForm = {
            'form': datosForm
        };
        this._dataSaveService.setFormularioCompraVehic(this.transmitter, auxForm);
    }

    saveDataFormCarroceria() {
        const datosForm = this.carroceria.getRawValue();
        const auxForm = {
            'form': datosForm
        };
        this._dataSaveService.setFormularioCarroceria(this.transmitter, auxForm);
    }

    reset() {
        this.carroceria.get('trasera').setValue(0, { emitEvent: false });
        this.carroceria.get('maletero').setValue(0, { emitEvent: false });
        this.carroceria.get('rtraseraIzq').setValue(0, { emitEvent: false });
        this.carroceria.get('rTraseraDch').setValue(0, { emitEvent: false });
        this.carroceria.get('aletaTrasIzq').setValue(0, { emitEvent: false });
        this.carroceria.get('aletaTrasDch').setValue(0, { emitEvent: false });
        this.carroceria.get('lunaTrasera').setValue(0, { emitEvent: false });
        this.carroceria.get('puertaTrasIzq').setValue(0, { emitEvent: false });
        this.carroceria.get('puertatrasDer').setValue(0, { emitEvent: false });
        this.carroceria.get('faldonIzq').setValue(0, { emitEvent: false });
        this.carroceria.get('faldonDer').setValue(0, { emitEvent: false });
        this.carroceria.get('puertaDelIzq').setValue(0, { emitEvent: false });
        this.carroceria.get('puertaDelDer').setValue(0, { emitEvent: false });
        this.carroceria.get('techo').setValue(0, { emitEvent: false });
        this.carroceria.get('ruedaDelIzq').setValue(0, { emitEvent: false });
        this.carroceria.get('ruedaDelDer').setValue(0, { emitEvent: false });
        this.carroceria.get('lunaDelantera').setValue(0, { emitEvent: false });
        this.carroceria.get('capo').setValue(0, { emitEvent: false });
        this.carroceria.get('frontal').setValue(0, { emitEvent: false });
        this.carroceria.get('aletaDelIzq').setValue(0, { emitEvent: false });
        this.carroceria.get('aletaDelDer').setValue(0, { emitEvent: false });
    }

    estadoVehiculo() {
        this._sendData.getVehicleState().subscribe((data: any) => {
            this.stateVehicle = data['contents'];
        });
    }

    public valueNormalizer = (text: Observable<string>) => text.pipe(map((Description: string) => {
        return {
            Value: this.vehicleStates[this.vehicleStates.length - 1].Value + 1,
            Description: Description
        };
    }))

    public valueNormalizerUbi = (text: Observable<string>) => text.pipe(map((Description: string) => {
        return {
            VOLOCATIONCODE: this.ubicaciones[this.ubicaciones.length - 1].Value + 1,
            Description: Description
        };
    }))

    validarFormularioVehiculos() {

        const validacionCampos = this.vehiculoForm.controls;

        switch (this.transmitter) {
            case 'gestionVehiculosCortesia':
            case 'stockVO':
            case 'presupuestosTaller':
                if (this.isNew) {
                    if (validacionCampos.PlateNumber.valid && validacionCampos.Vin.valid && validacionCampos.ModelYear.valid && validacionCampos.Description.valid && this.VinOk && this.matriculaOk) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    if (validacionCampos.PlateNumber.valid && validacionCampos.Description.valid && validacionCampos.ModelYear.valid) {
                        return false;
                    } else {
                        return true;
                    }
                }
            case 'gestionVehiculos':
            case 'gestionTerceros':
            case 'recepcionVehiculo':
                if (this.isNew) {
                    if (validacionCampos.PlateNumber.valid && validacionCampos.Vin.valid && validacionCampos.ModelYear.valid &&  validacionCampos.Description.valid && validacionCampos.ThirdParty.valid &&
                        validacionCampos.ThirdPartyDriverCode.valid && validacionCampos.ThirdPartyInvoiceCode.valid && this.VinOk && this.matriculaOk) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    if (validacionCampos.PlateNumber.valid && validacionCampos.Description.valid && validacionCampos.ModelYear.valid && validacionCampos.ThirdParty.valid &&
                        validacionCampos.ThirdPartyDriverCode.valid && validacionCampos.ThirdPartyInvoiceCode.valid) {
                        return false;
                    } else {
                        return true;
                    }
                }


        }
    }

    guardarDatos() {
        if (this.validarFormularioVehiculos()) {
        } else {
            if (this.statusFormSend === 'new') {
                const dataSend = this.vehiculoForm.getRawValue();
                // this._adjuntarDocumentosService.getMediaFileList().subscribe(
                //     data => {
                //         this.mediaFileList = data;
                //         console.log(this.mediaFileList );
                //     }
                // )

                let datos: any = {
                    'inputValue': {
                        'CLIENTCODE': null,
                        'COMPANYCODE': null,
                        'Chassis': null,
                        'ClearedPlate': null,
                        'Comment': dataSend['Comment'],
                        'Company': null,
                        'Description': dataSend['Description'],
                        'CustomerCode': dataSend['ThirdParty']['CustomerId'],
                        'DriverCode': dataSend['ThirdPartyDriverCode']['CustomerId'],
                        'CustomerInvoiceCode': dataSend['ThirdPartyInvoiceCode']['CustomerId'],
                        'EnginePower': dataSend['EnginePower'],
                        'GuaranteeDate': dataSend['GuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['GuaranteeDate']) : null,
                        'EndBrandGuaranteeDate': dataSend['EndBrandGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndBrandGuaranteeDate']) : null,
                        'EndPlusGuaranteeDate': dataSend['EndPlusGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndPlusGuaranteeDate']) : null,
                        'EndVendorGuaranteeDate': dataSend['EndVendorGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndVendorGuaranteeDate']) : null,
                        'SaleDate': dataSend['SaleDate'] != null ? this._globals.getDateFormatForServer(dataSend['SaleDate']) : null,
                        'MatriculationDate': dataSend['MatriculationDate'] != null ? this._globals.getDateFormatForServer(dataSend['MatriculationDate']) : null,
                        'GuaranteeDuration': dataSend['GuaranteeDuration'] != null ? dataSend['GuaranteeDuration'] : 0,
                        'GuaranteeType': dataSend['GuaranteeType'] != null ? dataSend['GuaranteeType'] : null,
                        'LastMatriculationDate': dataSend['LastMatriculationDate'] != null ? this._globals.getDateFormatForServer(dataSend['LastMatriculationDate']) : null,
                        'VehicleInspectionDate': dataSend['VehicleInspectionDate'] != null ? this._globals.getDateFormatForServer(dataSend['VehicleInspectionDate']) : null,
                        'GaranteeExtension': null,
                        'GuaranteeExtCode': dataSend['GuaranteeExtCode']['GARANTEEEXTCODE'],
                        'InsuranceFranchiseAmount': 0,
                        'InsuranceInsuranceCompany': null,
                        'InsurancePolicyNumber': null,
                        'InternalVehicleUse': dataSend['InternalVehicleUse'],
                        'KM': dataSend['KM'],
                        'LastInvoiceAmount': dataSend['LastInvoiceAmount'],
                        'LastRepairDate': dataSend['LastRepairDate'] != null ? this._globals.getDateFormatForServer(dataSend['LastRepairDate']) : null,
                        'LastRepairOrder': null,
                        'ModelCode': dataSend['ModelCode'],
                        'ModelGarageCode': null,
                        'NewUsedCar': true,
                        'NextVisitDate': dataSend['NextVisitDate'] != null ? this._globals.getDateFormatForServer(dataSend['NextVisitDate']) : null,
                        'OpbCode': dataSend['OpbCode'],
                        'OrganizationNumber': dataSend['OrganizationNumber'],
                        'PDVCity': null,
                        'PDVCode': null,
                        'PDVDescription': null,
                        'PlateNumber': dataSend['PlateNumber'],
                        'PlusDate': null,
                        'PlusKM': 0,
                        'RegistrarionSource': 'DMS',
                        'RegistrationDate': this._globals.getDateFormatForServer(this.fechaActual),
                        'RevocaDate': null,
                        'SaleType': null,
                        'TransmissionCode': '*',
                        'Type': dataSend['Type'],
                        'TypeKm': null,
                        'VOBuyPrice': 0,
                        'VODateCG': null,
                        'VOLocations': null,
                        'VOPolicyNumber': null,
                        'VOSaleDate': null,
                        'VOStockDestination': '**',
                        'VOStockSource': '**',
                        'VOStockStatus': '**',
                        'VOVATAmount': 0,
                        'VOVATDescription': null,
                        'VarnishCode': null,
                        'BrandCode': dataSend['BrandCode'],
                        'VehicleCodes': this.carData['VehicleCodes'],
                        'VehicleMediaFileList': this.mediaFileList,
                        'VehicleModelGarageCitroen': null,
                        'ModelYear': dataSend['ModelYear'] != null ? dataSend['ModelYear'] : null,
                        'VehicleModification': dataSend['VehicleModification'],
                        'VendorCode': dataSend['Vendor'] ? dataSend['Vendor'] : '***', // Garantia   //new
                        'Vin': dataSend['Vin'],
                    }
                };

                if(this.caractVehic){
                    const dataCaracVehic = this.caractVehic.getRawValue();
                    datos.inputValue = {
                        ...datos.inputValue,
                        'Seats': dataCaracVehic.Seats,
                        'BodyWork': dataCaracVehic.BodyWork,
                        'ExteriorColor': dataCaracVehic.ExteriorColor,
                        'InteriorColor': dataCaracVehic.InteriorColor,
                        'FiscalPower': dataCaracVehic.FiscalPower,
                        'Speed': dataCaracVehic.Speed,
                    }
                }

                if(this.compraVehic){
                    const dataCompraVehic = this.compraVehic.getRawValue();
                    datos.inputValue = {
                        ...datos.inputValue,
                        'VehicleCompanyCode': dataCompraVehic.VehicleCompanyCode,
                        'VehicleCompanyName': dataCompraVehic.VehicleCompanyName,
                        'SiteCode': dataCompraVehic.SiteCode,
                        'SiteLabel': dataCompraVehic.SiteLabel,
                        'LocationCode': dataCompraVehic.LocationCode,
                        'LocationDescription': dataCompraVehic.LocationDescription,
                        'SaleBuyerCode': dataCompraVehic.SaleBuyerCode,
                        'SaleBuyerName': dataCompraVehic.SaleBuyerName,
                        'VOSupplierCustomerName': dataCompraVehic.VOSupplierCustomerName
                    }
                }

                if (this.transmitter === 'gestionVehiculos') {
                    const CustomerKeeperCode = { CustomerKeeperCode: dataSend['CustomerKeeper']['CustomerId'] !== '' ? dataSend['CustomerKeeper']['CustomerId'] : null };
                    const CustomerPrescriberCode = { CustomerPrescriberCode: dataSend['CustomerPrescriber']['CustomerId'] !== '' ? dataSend['CustomerPrescriber']['CustomerId'] : null };
                    Object.assign(datos.inputValue, CustomerKeeperCode);
                    Object.assign(datos.inputValue, CustomerPrescriberCode);
                    this.addData(datos);
                } else if (this.transmitter === 'gestionVehiculosCortesia') {
                    datos.inputValue.CLIENTCODE = this._authService.getClientCode();
                    datos.inputValue.COMPANYCODE = this._authService.getCompanyCode();
                    const dataGestion = this.gestion.getRawValue();
                    const CarState = { VehicleState: dataGestion['vehiculoStatus'] !== 0 ? dataGestion['vehiculoStatus'] : null };
                    const LocationCode = { VOLocationCode: dataGestion['ubicacion'] !== 99 ? dataGestion['ubicacion'] : null };
                    Object.assign(datos.inputValue, CarState);
                    Object.assign(datos.inputValue, LocationCode);
                    this.seguirConAdd(datos);
                } else {
                    this.addData(datos);
                }

            } else {
                // ahora comprobamos si no hay ordenes en curso , abiertas o cerradas, tambien se comprueba que se haya modificado algunos campos concretos del formulario
                if ((this.ordenesAbiCurCerr && this.ordenesAbiCurCerr.length > 0) && this.checkDirtyFormFields()) {
                    this.vehiculoForm.markAsPristine();
                    this.showModalOrders = true;
                } else {
                    const InternalVehicleUse = this.vehiculoForm.get('InternalVehicleUse').value;
                    if (this.transmitter === 'gestionVehiculosCortesia' && InternalVehicleUse === 'VO') {
                        this.generic_popupName = 'cambioTipoVehiculo';
                        this.generic_aspa = false;
                        this.generic_isButtonOk = true;
                        this.generic_isButtonCancel = false;
                        this.generic_title = 'gestion_vehiculos_vc.gestionV';
                        this.generic_message = 'gestion_vehiculos_vc.msgPopupVC';
                        this.generic_textButtonOk = 'labels.si';
                        this.generic_textButtonCancel = 'labels.no';
                        this.showModalGeneric = true;
                    } else if (this.transmitter === 'stockVO' && InternalVehicleUse === 'VC') {
                        this.generic_popupName = 'cambioTipoVehiculo';
                        this.generic_aspa = false;
                        this.generic_isButtonOk = true;
                        this.generic_isButtonCancel = false;
                        this.generic_title = 'gestion_vehiculos_vc.gestionV';
                        this.generic_message = 'stock_vo.msgPopupVC';
                        this.generic_textButtonOk = 'labels.si';
                        this.generic_textButtonCancel = 'labels.no';
                        this.showModalGeneric = true;
                    } else {
                        this.seguirConGuardado();
                    }
                }
            }
        }
    }

    checkDirtyFormFields(): boolean{
        //vehicle tab
        const modelCode = this.vehiculoForm.get('ModelCode').dirty;
        const opbCode =  this.vehiculoForm.get('OpbCode').dirty;
        const organizationNumber = this.vehiculoForm.get('OrganizationNumber').dirty;
        const description = this.vehiculoForm.get('Description').dirty;

        // warranty tab
        const vendorName = this.vehiculoForm.get('VendorName').dirty;
        const saleDate = this.vehiculoForm.get('SaleDate').dirty;

        const result = modelCode || opbCode || organizationNumber || description || vendorName || saleDate;

        return result;
    }

    seguirConGuardado() {
        const dataSend = this.vehiculoForm.getRawValue();

        // this._adjuntarDocumentosService.getMediaFileList().subscribe(
        //     data => {
        //         this.mediaFileList = data;
        //         console.log(this.mediaFileList );
        //         console.log("Estoy dentro de SEGUIRconGUARDANDO" );
        //     }
        // )
        let datos: any = {
            'inputValue': {
                'CLIENTCODE': this._authService.getClientCode(),
                'COMPANYCODE': this._authService.getCompanyCode(),
                'Chassis': this.chassis,
                'ClearedPlate': null,
                'Comment': dataSend['Comment'],
                'Company': null,
                'Description': dataSend['Description'],
                'CustomerCode': dataSend['ThirdParty']['CustomerId'],
                'DriverCode': dataSend['ThirdPartyDriverCode']['CustomerId'],
                'CustomerInvoiceCode': dataSend['ThirdPartyInvoiceCode']['CustomerId'],
                'EnginePower': dataSend['EnginePower'],
                'GuaranteeDate': dataSend['GuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['GuaranteeDate']) : null,
                'EndBrandGuaranteeDate': dataSend['EndBrandGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndBrandGuaranteeDate']) : null,
                'EndPlusGuaranteeDate': dataSend['EndPlusGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndPlusGuaranteeDate']) : null,
                'EndVendorGuaranteeDate': dataSend['EndVendorGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndVendorGuaranteeDate']) : null,
                'SaleDate': dataSend['SaleDate'] != null ? this._globals.getDateFormatForServer(dataSend['SaleDate']) : null,
                'MatriculationDate': dataSend['MatriculationDate'] != null ? this._globals.getDateFormatForServer(dataSend['MatriculationDate']) : null,
                'GuaranteeDuration': dataSend['GuaranteeDuration'] != null ? dataSend['GuaranteeDuration'] : 0,
                'GuaranteeType': dataSend['GuaranteeType'] != null ? dataSend['GuaranteeType'] : null,
                'LastMatriculationDate': dataSend['LastMatriculationDate'] != null ? this._globals.getDateFormatForServer(dataSend['LastMatriculationDate']) : null,
                'VehicleInspectionDate': dataSend['VehicleInspectionDate'] != null ? this._globals.getDateFormatForServer(dataSend['VehicleInspectionDate']) : null,
                'LastRepairDate': dataSend['LastRepairDate'] != null ? this._globals.getDateFormatForServer(dataSend['LastRepairDate']) : null,
                'NextVisitDate': dataSend['NextVisitDate'] != null ? this._globals.getDateFormatForServer(dataSend['NextVisitDate']) : null,
                'RegistrationDate': this.carData['RegistrationDate'] != null ? this.carData['RegistrationDate'] : null,
                'LastRepairOrder': null,
                'GaranteeExtension': null,
                'GuaranteeExtCode': dataSend['GuaranteeExtCode'],
                'InsuranceFranchiseAmount': 0,
                'InsuranceInsuranceCompany': null,
                'InsurancePolicyNumber': null,
                'InternalVehicleUse': dataSend['InternalVehicleUse'],
                'KM': dataSend['KM'],
                'LastInvoiceAmount': dataSend['LastInvoiceAmount'],
                'ModelCode': dataSend['ModelCode'],
                'ModelGarageCode': null,
                'NewUsedCar': true,
                'OpbCode': dataSend['OpbCode'],
                'OrganizationNumber': dataSend['OrganizationNumber'],
                'PDVCity': null,
                'PDVCode': null,
                'PDVDescription': null,
                'PlateNumber': dataSend['PlateNumber'],
                'PlusDate': null,
                'PlusKM': 0,
                'RegistrarionSource': 'DMS',
                'RevocaDate': null,
                'SaleType': null,
                'TransmissionCode': '*',
                'Type': dataSend['Type'],
                'TypeKm': null,
                'VOBuyPrice': 0,
                'VODateCG': null,

                'VOLocations': null,
                'VOPolicyNumber': null,
                'VOSaleDate': null,
                'VOStockDestination': '**',
                'VOStockSource': '**',
                'VOStockStatus': '**',
                'VOVATAmount': 0,
                'VOVATDescription': null,
                'VarnishCode': null,
                'BrandCode': dataSend['BrandCode'],
                'VehicleCodes': this.carData['VehicleCodes'],
                //'VehicleMediaFileList':this.carData['VehicleMediaFileList'],
                'VehicleMediaFileList': this.mediaFileList,
                'VehicleModelGarageCitroen': null,
                'ModelYear': dataSend['ModelYear'] != null ? dataSend['ModelYear'] : null,
                'VehicleModification': dataSend['VehicleModification'],
                'VendorCode': dataSend['Vendor'] ? dataSend['Vendor'] : '***', // Garantia modificar
                'Vin': dataSend['Vin']
            }
        };

        if(this.caractVehic){
            const dataCaracVehic = this.caractVehic.getRawValue();
            datos.inputValue = {
                ...datos.inputValue,
                'Seats': dataCaracVehic.Seats,
                'BodyWork': dataCaracVehic.BodyWork,
                'ExteriorColor': dataCaracVehic.ExteriorColor,
                'InteriorColor': dataCaracVehic.InteriorColor,
                'FiscalPower': dataCaracVehic.FiscalPower,
                'Speed': dataCaracVehic.Speed,
            }

        }
        if(this.compraVehic){
            const dataCompraVehic = this.compraVehic.getRawValue();
            datos.inputValue = {
                ...datos.inputValue,
                'VehicleCompanyCode': dataCompraVehic.VehicleCompanyCode,
                'VehicleCompanyName': dataCompraVehic.VehicleCompanyName,
                'SiteCode': dataCompraVehic.SiteCode,
                'SiteLabel': dataCompraVehic.SiteLabel,
                'LocationCode': dataCompraVehic.LocationCode,
                'LocationDescription': dataCompraVehic.LocationDescription,
                'SaleBuyerCode': dataCompraVehic.SaleBuyerCode,
                'SaleBuyerName': dataCompraVehic.SaleBuyerName,
                'VOSupplierCustomerName': dataCompraVehic.VOSupplierCustomerName
            }
        }
        if (this.transmitter === 'gestionVehiculos') {
            const CustomerKeeperCode = { CustomerKeeperCode: dataSend['CustomerKeeper']['CustomerId'] !== '' ? dataSend['CustomerKeeper']['CustomerId'] : null };
            const CustomerPrescriberCode = { CustomerPrescriberCode: dataSend['CustomerPrescriber']['CustomerId'] !== '' ? dataSend['CustomerPrescriber']['CustomerId'] : null };
            Object.assign(datos.inputValue, CustomerKeeperCode);
            Object.assign(datos.inputValue, CustomerPrescriberCode);
        }

        if (this.transmitter === 'gestionVehiculosCortesia' || this.transmitter === 'stockVO') {
            const dataGestion = this.gestion.getRawValue();
            const LocationCode = { VOLocationCode: dataGestion['ubicacion'] !== 99 ? dataGestion['ubicacion'] : null };
            Object.assign(datos.inputValue, LocationCode);

            const CarState = { VehicleState: dataGestion['vehiculoStatus'] !== 0 ? dataGestion['vehiculoStatus'] : null };
            Object.assign(datos.inputValue, CarState);
            this.updateCarroceria();

        }

        this.updateData(datos);

    }



    closeModalOrder(result) {
        if (result.guardado === 'guardar') {
            const datosOrdenSeleccionada = result.datos;
            this.seguirConGuardado();
        }

        this.showModalOrders = false;
    }

    verificarValor(valor) {
        switch (valor) {
            case 0:
                return 'Correcto';
            case 1:
                return 'Defectuoso';
        }
    }
    nuevosValor(item) {
        const dataCarroceria = this.carroceria.getRawValue();

        switch (item.PointID) {
            case 0:
                item.PointState = dataCarroceria.frontal;
                item.PointStateDescription = this.verificarValor(dataCarroceria.frontal);
                return item;
            case 1:
                item.PointState = dataCarroceria.capo;
                item.PointStateDescription = this.verificarValor(dataCarroceria.capo);
                return item;
            case 2:
                item.PointState = dataCarroceria.ruedaDelDer;
                item.PointStateDescription = this.verificarValor(dataCarroceria.ruedaDelDer);
                return item;
            case 3:
                item.PointState = dataCarroceria.ruedaDelIzq;
                item.PointStateDescription = this.verificarValor(dataCarroceria.ruedaDelIzq);
                return item;
            case 4:
                item.PointState = dataCarroceria.aletaDelDer;
                item.PointStateDescription = this.verificarValor(dataCarroceria.aletaDelDer);
                return item;
            case 5:
                item.PointState = dataCarroceria.aletaDelIzq;
                item.PointStateDescription = this.verificarValor(dataCarroceria.aletaDelIzq);
                return item;
            case 6:
                item.PointState = dataCarroceria.lunaDelantera;
                item.PointStateDescription = this.verificarValor(dataCarroceria.lunaDelantera);
                return item;
            case 7:
                item.PointState = dataCarroceria.puertaDelDer;
                item.PointStateDescription = this.verificarValor(dataCarroceria.puertaDelDer);
                return item;
            case 8:
                item.PointState = dataCarroceria.puertaDelIzq;
                item.PointStateDescription = this.verificarValor(dataCarroceria.puertaDelIzq);
                return item;
            case 9:
                item.PointState = dataCarroceria.faldonDer;
                item.PointStateDescription = this.verificarValor(dataCarroceria.faldonDer);
                return item;
            case 10:
                item.PointState = dataCarroceria.faldonIzq;
                item.PointStateDescription = this.verificarValor(dataCarroceria.faldonIzq);
                return item;
            case 11:
                item.PointState = dataCarroceria.puertatrasDer;
                item.PointStateDescription = this.verificarValor(dataCarroceria.puertatrasDer);
                return item;
            case 12:
                item.PointState = dataCarroceria.puertaTrasIzq;
                item.PointStateDescription = this.verificarValor(dataCarroceria.puertaTrasIzq);
                return item;
            case 13:
                item.PointState = dataCarroceria.techo;
                item.PointStateDescription = this.verificarValor(dataCarroceria.techo);
                return item;
            case 14:
                item.PointState = dataCarroceria.rTraseraDch;
                item.PointStateDescription = this.verificarValor(dataCarroceria.rTraseraDch);
                return item;
            case 15:
                item.PointState = dataCarroceria.rtraseraIzq;
                item.PointStateDescription = this.verificarValor(dataCarroceria.rtraseraIzq);
                return item;
            case 16:
                item.PointState = dataCarroceria.lunaTrasera;
                item.PointStateDescription = this.verificarValor(dataCarroceria.lunaTrasera);
                return item;
            case 17:
                item.PointState = dataCarroceria.maletero;
                item.PointStateDescription = this.verificarValor(dataCarroceria.maletero);
                return item;
            case 18:
                item.PointState = dataCarroceria.trasera;
                item.PointStateDescription = this.verificarValor(dataCarroceria.trasera);
                return item;
            case 19:
                item.PointState = dataCarroceria.aletaTrasDch;
                item.PointStateDescription = this.verificarValor(dataCarroceria.aletaTrasDch);
                return item;
            case 20:
                item.PointState = dataCarroceria.aletaTrasIzq;
                item.PointStateDescription = this.verificarValor(dataCarroceria.aletaTrasIzq);
                return item;

        }

    }

    updateCarroceria() {
        const dataCarroceria = this.carroceria.getRawValue();

        if (this.vehicleValuationDetailList && this.vehicleValuationDetailList.length > 0) {
            this.vehicleValuationDetailList.forEach(element => {
                element = this.nuevosValor(element);
            });
            const params = {
                inputValue: {
                    CHASSIS: this.chassis,
                    CLIENTCODE: this._authService.getClientCode(),
                    COMPANYCODE: this._authService.getCompanyCode(),
                    CreationDate: this.creationDate,
                    ID: this.ID,
                    Vehicle: null,
                    VehicleValuationDetailList: this.vehicleValuationDetailList
                },
            };

            const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleValuationService.svc/Update`;

            this._sendData.setDataSend(_URL_, params).subscribe((data: any) => {
                const auxdata = data.Response;

            });
        }

    }

    // cambio de propietario
    ngOnChanges() {
        if (this.newOwnerData) {
            // this.getSearchInfo(this.newOwnerData);
        }
    }

    selectRowSecurity(event: any) {
        this.segurityCode = event.dataItem;
        this.rowCode = event['rowIndex'];
        this.botonNuevo = true;
        this.edit = false;
        this.remove = false;
    }

    getFactTranslate(faType) {
        let auxText = '';
        switch (faType) {
            case 'AB':
                this.translateService.get('labels.abierta').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'AN':
                this.translateService.get('labels.anulada').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'CC':
                this.translateService.get('labels.cerrada').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'EC':
                this.translateService.get('labels.encurso').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'FA':
                this.translateService.get('labels.facturada').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'FP':
                this.translateService.get('labels.facturada_parc').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'PF':
                this.translateService.get('labels.pendiente_fact').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'PA':
                this.translateService.get('labels.presupuesto_abi').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'PC':
                this.translateService.get('labels.presupuesto_acep').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'PE':
                this.translateService.get('labels.presupuesto_curso').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'PN':
                this.translateService.get('labels.presupuesto_no_acep').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'CE':
                this.translateService.get('labels.presupuesto_cerr').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'RA':
                this.translateService.get('labels.reabierta').subscribe(text => {
                    auxText = text;
                });
                break;
            case 'PI':
                this.translateService.get('labels.ciservice').subscribe(text => {
                    auxText = text;
                });
                break;
            default:
                auxText = '';
                break;
        }
        return auxText;
    }

    guardarCodigos() {
    }

    clearValueInput() {
        this.inputCode.nativeElement.value = '';
        this.textACode.nativeElement.value = '';
        this.botonNuevo = false;
        this.edit = true;
        this.remove = true;
    }

    openModalVehicle() {
        this.showModalVehicle = true;
    }

    closeModalVehicle(result) {
        if (result.datosForm) {
            this.vehiculoForm.get('ModelCode').setValue(result.datosForm.Version16);
            this.vehiculoForm.get('Description').setValue(result.datosForm.VersionText);
        }
        this.showModalVehicle = false;
    }

    openModalPhone() {
        this.showModalPhone = true;
    }

    closeModalPhone(result) {
        this.showModalPhone = false;
    }


    openVendor() {
        this.showModalVendors = true;
    }

    closeModalVendors(result) {
        this.showModalVendors = false;

        if (result !== 'cerrar') {
            this.customResult = result;
            const VendorName = this.customResult.Name;
            const VENDORCODE = this.customResult.VENDORCODE;
            this.vehiculoForm.get('VendorName').setValue(VendorName);
            this.vehiculoForm.get('Vendor').setValue(VENDORCODE);
        }
    }

    getInformationTypeClient(search: string) {
        this.tipoSearch = '';
        if (search === '') {
            switch (this.ownerChangeString) {
                case 'customercode':
                    break;
                case 'customername':
                    this.customercode.nativeElement.value = '';
                    this.customername.nativeElement.value = '';
                    break;
                case 'customercodedriver':
                    break;
                case 'customernamedriver':
                    this.customercodedriver.nativeElement.value = '';
                    this.customernamedriver.nativeElement.value = '';
                    break;
                case 'customercodeinvoice':
                    break;
                case 'customernameinvoice':
                    this.customercodeinvoice.nativeElement.value = '';
                    this.customernameinvoice.nativeElement.value = '';
                    break;
                case 'customerCodePrescriberCode':
                    break;
                case 'customerNamePrescriberCode':
                    this.customerCodePrescriberCode.nativeElement.value = '';
                    this.customerNamePrescriberCode.nativeElement.value = '';
                    break;
                case 'customerKeeperCode':
                    break;
                case 'customerKeeperName':
                    this.customerKeeperCode.nativeElement.value = '';
                    this.customerKeeperName.nativeElement.value = '';
                    break;
            }
        } else {
            switch (this.ownerChangeString) {
                case 'customercode':
                case 'customercodedriver':
                case 'customercodeinvoice':
                case 'customerCodePrescriberCode':
                case 'customerKeeperCode':
                    this.tipoSearch = 'C';
                    break;
                case 'customername':
                case 'customernamedriver':
                case 'customernameinvoice':
                case 'customerNamePrescriberCode':
                case 'customerKeeperName':
                    this.tipoSearch = 'N';
                    break;
            }

            this.informationClientSearchBox(search);
        }
    }

    // Caja de resultados
    informationClientSearchBox(search: string) {
        this.loadingData = true;
        const _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/GetAllCustomer`;
        const params = {
            'customerSearchClientCode': '',
            'customerName': '',
            'customerFiscalCode': '',
            'pageInfo': { 'Number': 1, 'Size': 40 },
            'entityState': 0
        };
        if (this.tipoSearch == 'C') {
            params.customerSearchClientCode = search;
        } else {
            params.customerName = search;
        }

        this._dataVehiculosService.getInformationClientSearch(_URL_, params).subscribe(data => {
            const auxData = data.Response.Content;

            if (auxData) {
                this.informationClientSearch = auxData;
                if (this.informationClientSearch.length > 0) {
                    this.getSearchInfoBoxResults(this.informationClientSearch[0]);
                }

            } else {
                this.informationClientSearch = [];
            }
        });
        setTimeout(() => {
            this.loadingData = false;
        }, 500);
    }


    copyToClipboard() {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = this.vehiculoForm.get('Vin').value;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);

    }

    getVinForServiboxIcon() {
        return this.vehiculoForm ? this.vehiculoForm.get('Vin').value : '';
    }

    onTabSelect(event) {
        if (event.index === 1) {
            this.informationBox = false;
            this.boxSearch = true;
        } else {
            this.informationBox = true;
            this.boxSearch = false;
        }

        const auxTab = {
            'tab': event.index
        };
        this._dataSaveService.setTabsView(this.transmitter, auxTab);
        switch (event.index) {
            case 0:
                break;
            case 1:
                break;
            case 5:
                break;
            case 6:
                break;
            case 7:
                this.tablaCitas();
                break;
        }
        this.comprobarPestana();
    }


    // Evento al hacer click en la Caja de resultados de la pestaña Propietarios
    getSearchInfoBoxResults(data: object) {
        this.newOwnerData = data;
        // this.getSearchInfo(this.newOwnerData);
    }

    clickGetSearchInfoBoxResults(data: object) {
        this.newOwnerData = data;
        this.getSearchInfo(this.newOwnerData);
        this.comprobarPestana();
    }

    getFocusAction() {
        // la referencia al elemento puede no existir cuando se llama la funcion y haya que esperar a que se cree
        if (this.inputCode) {
            if (this.inputCode.nativeElement.value !== '' || this.inputCode.nativeElement.value !== '') {
                this.botonNuevo = false;
            }
        } else {
            this.inputCodeQuery.changes.pipe(take(1)).subscribe((componentes: QueryList<ElementRef>) => {
                if (componentes.first.nativeElement.value !== '' || componentes.first.nativeElement.value !== '') {
                    this.botonNuevo = false;
                }
            });
        }
    }

    getAnterior() {
        this.anterior.emit(0);

        this._dataSaveService.setFormulario(this.transmitter, { 'form': null });
        this._dataSaveService.setStepsView(this.transmitter, { 'step': 1 });
        this._dataSaveService.setTabsView(this.transmitter, { 'tab': 0 });
        this._dataSaveService.setDatosRowTabla(this.transmitter, {});
        this.objetoPaginacion = {
            'skip': 0,
            'pageNumber': 1,
            'pageSize': 20
        };
        this._dataSaveService.setDatosPaginacion(this.transmitter, this.objetoPaginacion);
    }

    getSearchInfo(data: object) {
        this.TelephonePortable = data['TelephonePortable'];
        this.CustomerName = data['CustomerName'];
        this.CustomerCode = data['CustomerCode'];
        this.FiscalCode = data['FiscalCode'];
        this.TelephoneHome = data['TelephoneHome'];

        switch (this.ownerChangeString) {
            case 'customercode':
            case 'customername':

                this.customercode.nativeElement.value = data['CustomerCode'];
                this.customername.nativeElement.value = data['CustomerName'];

                this.vehiculoForm.get('ThirdParty').get('CustomerId').setValue(data['CustomerId'], { eventEmit: false });
                this.vehiculoForm.get('ThirdParty').get('CustomerCode').setValue(data['CustomerCode'], { eventEmit: false });
                this.vehiculoForm.get('ThirdParty').get('CustomerName').setValue(data['CustomerName'], { eventEmit: false });

                this.ThirdParty = data;
                break;
            case 'customercodedriver':
            case 'customernamedriver':
                this.customercodedriver.nativeElement.value = data['CustomerCode'];
                this.customernamedriver.nativeElement.value = data['CustomerName'];

                this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerId').setValue(data['CustomerId'], { eventEmit: false });
                this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerCode').setValue(data['CustomerCode'], { eventEmit: false });
                this.vehiculoForm.get('ThirdPartyDriverCode').get('CustomerName').setValue(data['CustomerName'], { eventEmit: false });
                this.ThirdPartyDriverCode = data;
                break;
            case 'customercodeinvoice':
            case 'customernameinvoice':
                this.customercodeinvoice.nativeElement.value = data['CustomerCode'];
                this.customernameinvoice.nativeElement.value = data['CustomerName'];

                this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerId').setValue(data['CustomerId'], { eventEmit: false });
                this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerCode').setValue(data['CustomerCode'], { eventEmit: false });
                this.vehiculoForm.get('ThirdPartyInvoiceCode').get('CustomerName').setValue(data['CustomerName'], { eventEmit: false });

                this.ThirdPartyInvoiceCode = data;
                break;

            case 'customerCodePrescriberCode':
            case 'customerNamePrescriberCode':
                this.customerCodePrescriberCode.nativeElement.value = data['CustomerCode'];
                this.customerNamePrescriberCode.nativeElement.value = data['CustomerName'];

                this.vehiculoForm.get('CustomerPrescriber').get('CustomerId').setValue(data['CustomerId'], { eventEmit: false });
                this.vehiculoForm.get('CustomerPrescriber').get('CustomerCode').setValue(data['CustomerCode'], { eventEmit: false });
                this.vehiculoForm.get('CustomerPrescriber').get('CustomerName').setValue(data['CustomerName'], { eventEmit: false });

                this.CustomerPrescriber = data;
                break;
            case 'customerKeeperCode':
            case 'customerKeeperName':
                this.customerKeeperCode.nativeElement.value = data['CustomerCode'];
                this.customerKeeperName.nativeElement.value = data['CustomerName'];

                this.vehiculoForm.get('CustomerKeeper').get('CustomerId').setValue(data['CustomerId'], { eventEmit: false });
                this.vehiculoForm.get('CustomerKeeper').get('CustomerCode').setValue(data['CustomerCode'], { eventEmit: false });
                this.vehiculoForm.get('CustomerKeeper').get('CustomerName').setValue(data['CustomerName'], { eventEmit: false });

                this.CustomerKeeper = data;
                break;
        }

    }

    actions(action: string, code, desc) {
        const security = this.segurity[0]['gridView']['data'];
        const valorCode = code.nativeElement.value;
        const valorDescripcion = desc.nativeElement.value;

        if (this.rowCode === -1) {
            return;
        }
        switch (action) {
            case 'edit':
                security[this.rowCode]['VEHICLECODE'] = valorCode;
                security[this.rowCode]['Value'] = valorDescripcion;
                this.clearValueInput();
                break;
            case 'remove':

                this.eliminarContacto();
                this.clearValueInput();
                break;
            default:
        }
        this.rowCode = -1;
    }

    eliminarContacto() {
        const auxVehicles = this.carData['VehicleCodes'];
        const index = this.rowCode;
        auxVehicles.splice(index, 1);
        this.carData['VehicleCodes'] = auxVehicles;
    }

    addRegister(code, desc) {
        const valorCode = code.nativeElement.value;
        const valorDescripcion = desc.nativeElement.value;

        this.carData['VehicleCodes'].push(
            {
                CHASSIS: this.carData['Chassis'],
                CLIENTCODE: this.carData['CLIENTCODE'],
                COMPANYCODE: this.carData['COMPANYCODE'],
                VEHICLECODE: valorCode,
                Value: valorDescripcion
            });

        this.clearValueInput();
        this.botonNuevo = true;
    }

    ownerChange(inputInfo: string) {
        this.ownerChangeString = inputInfo;
    }

    addVehiculo() { // solo para gestion terceros
        if (this.vehiculoForm.invalid) {
        } else {
            const dataSend = this.vehiculoForm.value;
            let datos: any = {
                'inputValue': {
                    'CLIENTCODE': this.recepcionVO ? this._authService.getCustomerCode() : null,
                    'COMPANYCODE': this.recepcionVO ? this._authService.getCompanyCode() : null,
                    'Chassis': null,     // this.chassis, ?? no tengo el dato si es nuevo
                    'ClearedPlate': null,
                    'Comment': dataSend['Comment'],
                    'Company': null,
                    'Description': dataSend['Description'],
                    'CustomerCode': this.recepcionVO ? null : dataSend['ThirdParty'].CustomerId,
                    'DriverCode': this.recepcionVO ? null : dataSend['ThirdPartyDriverCode'].CustomerId,
                    'CustomerInvoiceCode': dataSend['ThirdPartyInvoiceCode'].CustomerId,
                    'EnginePower': dataSend['EnginePower'],
                    'GuaranteeDate': dataSend['GuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['GuaranteeDate']) : null,
                    'EndBrandGuaranteeDate': dataSend['EndBrandGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndBrandGuaranteeDate']) : null,
                    'EndPlusGuaranteeDate': dataSend['EndPlusGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndPlusGuaranteeDate']) : null,
                    'EndVendorGuaranteeDate': dataSend['EndVendorGuaranteeDate'] != null ? this._globals.getDateFormatForServer(dataSend['EndVendorGuaranteeDate']) : null,
                    'SaleDate': dataSend['SaleDate'] != null ? this._globals.getDateFormatForServer(dataSend['SaleDate']) : null,
                    'MatriculationDate': dataSend['MatriculationDate'] != null ? this._globals.getDateFormatForServer(dataSend['MatriculationDate']) : null,
                    'GuaranteeDuration': dataSend['GuaranteeDuration'] != null ? dataSend['GuaranteeDuration'] : 0,
                    'LastMatriculationDate': dataSend['LastMatriculationDate'] != null ? this._globals.getDateFormatForServer(dataSend['LastMatriculationDate']) : null,
                    'VehicleInspectionDate': dataSend['VehicleInspectionDate'] != null ? this._globals.getDateFormatForServer(dataSend['VehicleInspectionDate']) : null,
                    'GaranteeExtension': null,
                    'GuaranteeExtCode': dataSend['GuaranteeExtCode'],
                    'GuaranteeType': dataSend['GuaranteeType'] != null ? dataSend['GuaranteeType'] : null,
                    'InsuranceFranchiseAmount': 0,
                    'InsuranceInsuranceCompany': null,
                    'InsurancePolicyNumber': null,
                    'InternalVehicleUse': 'NI',
                    'KM': dataSend['KM'],
                    'LastInvoiceAmount': dataSend['LastInvoiceAmount'],
                    'LastRepairDate': dataSend['LastRepairDate'] != null ? this._globals.getDateFormatForServer(dataSend['LastRepairDate']) : null,
                    'LastRepairOrder': null,
                    'ModelCode': dataSend['ModelCode'],
                    'ModelGarageCode': null,
                    'NewUsedCar': true,
                    'NextVisitDate': dataSend['NextVisitDate'] != null ? this._globals.getDateFormatForServer(dataSend['NextVisitDate']) : null,
                    'OpbCode': dataSend['OpbCode'],
                    'OrganizationNumber': dataSend['OrganizationNumber'],
                    'PDVCity': null,
                    'PDVCode': null,
                    'PDVDescription': null,
                    'PlateNumber': dataSend['PlateNumber'],
                    'PlusDate': null,
                    'PlusKM': 0,
                    'RegistrarionSource': 'DMS',
                    'RegistrationDate': this._globals.getDateFormatForServer(this.fechaActual),
                    'RevocaDate': null,
                    'SaleType': null,
                    'TransmissionCode': '*',
                    'Type': dataSend['Type'],
                    'TypeKm': null,
                    'VOBuyPrice': 0,
                    'VODateCG': null,

                    'VOLocations': null,
                    'VOPolicyNumber': null,
                    'VOSaleDate': null,
                    'VOStockDestination': '**',
                    'VOStockSource': '**',
                    'VOStockStatus': '**',
                    'VOVATAmount': 0,
                    'VOVATDescription': null,
                    'VarnishCode': null,
                    'BrandCode': dataSend['BrandCode'],
                    'VehicleCodes': this.carData['VehicleCodes'],
                    'VehicleMediaFileList': this.carData['VehicleMediaFileList'],
                    'VehicleModelGarageCitroen': null,
                    'ModelYear': dataSend['ModelYear'] != null ? dataSend['ModelYear'] : null,

                    'VehicleModification': dataSend['VehicleModification'],
                    'VehicleState': null,
                    'VOLocationCode': null,
                    'VendorCode': dataSend['Vendor'] ? dataSend['Vendor'] : '***', // Garantia
                    'Vin': dataSend['Vin'],
                }
            };

            if(this.caractVehic){
                const dataCaracVehic = this.caractVehic.getRawValue();
                datos.inputValue = {
                    ...datos.inputValue,
                    'Seats': dataCaracVehic.Seats,
                    'BodyWork': dataCaracVehic.BodyWork,
                    'ExteriorColor': dataCaracVehic.ExteriorColor,
                    'InteriorColor': dataCaracVehic.InteriorColor,
                    'FiscalPower': dataCaracVehic.FiscalPower,
                    'Speed': dataCaracVehic.Speed,
                }
            }

            if(this.compraVehic){
                const dataCompraVehic = this.compraVehic.getRawValue();
                datos.inputValue = {
                    ...datos.inputValue,
                    'VehicleCompanyCode': dataCompraVehic.VehicleCompanyCode,
                    'VehicleCompanyName': dataCompraVehic.VehicleCompanyName,
                    'SiteCode': dataCompraVehic.SiteCode,
                    'SiteLabel': dataCompraVehic.SiteLabel,
                    'LocationCode': dataCompraVehic.LocationCode,
                    'LocationDescription': dataCompraVehic.LocationDescription,
                    'SaleBuyerCode': dataCompraVehic.SaleBuyerCode,
                    'SaleBuyerName': dataCompraVehic.SaleBuyerName,
                    'VOSupplierCustomerName': dataCompraVehic.VOSupplierCustomerName
                }
            }
            this.addData(datos);
        }
    }

    seguirConAdd(params1) {
        this.addDataVO(params1);
    }

    addDataVO(parametros) {
        const _URL_ = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/Add`;
        this._sendData.addData(_URL_, parametros).subscribe((data: any) => {
            const auxData = data.Response;
            if (auxData) {
                this.chassis = auxData.Chassis;
                this.actualizarCarroceria();
            }
        });

    }

    actualizarCarroceria() {
        const vehicleValuationDetailList = Carroceria;
        vehicleValuationDetailList.forEach(element => {
            element = this.nuevosValor(element);
        });

        const params2 = {
            item: {
                CHASSIS: this.chassis,
                CLIENTCODE: null,
                COMPANYCODE: null,
                CreationDate: this._globals.getDateFormatForServer(this.fechaActual),
                ID: 0,
                Vehicle: null,
                VehicleValuationDetailList: vehicleValuationDetailList
            },
        };
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleValuationService.svc/add`;
        this._sendData.setDataSend(_URL_, params2).subscribe((data: any) => {
            const auxdata = data.Response;
            if (auxdata) {
                this.translateService.get('genericos.toastr.successfulAdd').subscribe(text => {
                    this.toastr.success(text);
                });
            }
        });
        this.getAnterior();
    }

    addData(parametros) {
        let _URL_ = '';
        switch (this.transmitter) {
            case 'gestionVehiculosCortesia':
            case 'stockVO':
                _URL_ = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/Add`;
                break;
            case 'recepcionVO':
                _URL_ = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/Add`;
                break;
            default:
                _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/Add`;
                break;
        }

        this._sendData.addData(_URL_, parametros).subscribe((data: any) => {
            if (data) {
                this.translateService.get('genericos.toastr.successfulAdd').subscribe(text => {
                    this.toastr.success(text);
                    if (this.transmitter === 'recepcionVehiculo') {
                        this.generic_popupName = 'altaVehiculo';
                        this.generic_aspa = false;
                        this.generic_isButtonOk = true;
                        this.generic_isButtonCancel = false;
                        this.generic_title = 'labels.aviso';
                        this.generic_message = 'gestion_terceros.popup.altaVehiculo';
                        this.generic_textButtonOk = 'labels.aceptar';
                        this.generic_textButtonCancel = 'labels.cancelar';
                        this.showModalGeneric = true;
                        this.onDataRegister.emit(data.Response);
                    }
                    if (this.transmitter === 'recepcionVO' || this.presupuestosTaller) {
                        this.onDataRegister.emit(data.Response);
                    }
                });
            } else {
                this.translateService.get('genericos.toastr.errorAnadir').subscribe(res => {
                    this.toastr.error(res);
                });
            }

        });

        if (this.transmitter === 'gestionTerceros') {
            this._dataVehiculosService.setGuardar(true);
        }

        this.getAnterior();
    }

    closeModalGeneric(event) {
        this.showModalGeneric = false;
        if (event.nombrePopup === 'altaVehiculo' && event.datosPopup === 'aceptar') {
            this._recepcionVehiculoStepsService.setUpdate();
            this.cancel.emit(true);
        }
        if (event.nombrePopup === 'cambioTipoVehiculo' && event.datosPopup === 'aceptar') {
            this.seguirConGuardado();
        }
        if (event.nombrePopup === 'bajaVehiculo' && event.datosPopup === 'aceptar') {
            this.seguirBaja();
        }
        if (event.nombrePopup === 'bajaVehiculoOK' && event.datosPopup === 'aceptar') {
            this.siBaja = true;
        }
        if (event.nombrePopup === 'vehiculoReactivado' && event.datosPopup === 'aceptar') {
            this.siBaja = false;
        }

    }

    seguirBaja() {
        const parametros = { searchValue: this.carData.Chassis };
        const _URL_ = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/DeactivateByChassis`;

        this._sendData.bajaBehiculo(_URL_, parametros).subscribe((data: any) => {
            if (data) {
                this.translateService.get('genericos.toastr.successfulDesactivar').subscribe(text => {
                    this.toastr.success(text);
                });

                this.generic_popupName = 'bajaVehiculoOK';
                this.generic_aspa = false;
                this.generic_isButtonOk = true;
                this.generic_isButtonCancel = false;
                this.generic_title = 'gestion_vehiculos_vc.gestionV';
                this.generic_message = 'messagesInfo_OK.vehicleCancelOK';
                this.generic_textButtonOk = 'labels.aceptar';
                this.generic_textButtonCancel = 'labels.no';
                this.showModalGeneric = true;
            }
        });

    }

    cancelarOut() {
        this._dataVehiculosService.setCancelar(true);
    }

    cancelarVehiculoRecepcion() {
        this.cancel.emit(true);
    }

    darBaja() {
        this.generic_popupName = 'bajaVehiculo';
        this.generic_aspa = false;
        this.generic_isButtonOk = true;
        this.generic_isButtonCancel = true;
        this.generic_title = 'gestion_vehiculos_vc.gestionV';
        this.generic_message = 'alerts.bajaVehiculo';
        this.generic_textButtonOk = 'labels.si';
        this.generic_textButtonCancel = 'labels.no';
        this.showModalGeneric = true;
    }

    updateData(parametros) {
        let _URL_ = '';
        const _URL_2 = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/UpdateCarDataByChassis`;
        switch (this.transmitter) {
            case 'gestionVehiculosCortesia':
            case 'stockVO':
                _URL_ = `${environment.ENTORNO}Services/VO/WorkshopVehiclesService.svc/Update`;
                break;
            default:
                _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/Update`;
                break;
        }

        if (this.showModalOrders) {

            this._sendData.setDataSend(_URL_, parametros).subscribe((data: any) => {
                this._sendData.setDataSend(_URL_2, {chassis: parametros.inputValue.Chassis}).subscribe((data: any) => {

                    if (data) {
                        this.translateService.get('genericos.toastr.successfulSave').subscribe(text => {
                            this.toastr.success(text);
                        });
                    } else {
                        this.translateService.get('genericos.toastr.errorGuardado').subscribe(res => {
                            this.toastr.error(res);
                        });
                    }
                });
            });


        } else {

            this._sendData.setDataSend(_URL_, parametros).subscribe((data: any) => {

                if (data) {
                    this.translateService.get('genericos.toastr.successfulSave').subscribe(text => {
                        this.toastr.success(text);
                    });
                } else {
                    this.translateService.get('genericos.toastr.errorGuardado').subscribe(res => {
                        this.toastr.error(res);
                    });
                }
            });


        }
    }


    search(event) {
        const query = event.query;
        if (query != null && query.length > 0) {
            if (this.filial === 'AP') {
                this.cargarPeugeot(query, false);
            } else if (this.filial === 'AC' || this.filial === 'ER') {
                this.cargarCitroen();
            }
        }
    }

    onInputClick() {
        if (this.filial === 'AP') {
            this.cargarPeugeot('', false);
        } else if (this.filial === 'AC') {
            this.cargarCitroen();
        }
    }

    cargarCitroen() {
        const query = this.vehiculoForm.get('Opb').value;
        if (query != null && query.length > 0) {

            const params = {
                searchValue: query,
                pageInfo: { Number: 1, Size: 10 }
            };
            const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleModelService.svc/GetAllModelsOPB`;
            this._dataVehiculosService.getDataOpb(_URL_, params).subscribe((data: any) => {
                let arrayOpb = [];
                const auxData = data.Response.Content;
                if (auxData) {
                    arrayOpb = auxData;

                    this.dataOpb = this.filterOpb(query, arrayOpb);
                } else {
                    this.dataOpb = [];
                }
            });
        }
    }

    cargarPeugeot(query: string, formulario: boolean): void {
        const params = {
            'searcbValue': query.trim()
        };

        const _URL_ = `${environment.ENTORNO}Services/Workshop/PeugeotModelsService.svc/Find`;
        this._dataVehiculosService.getDataOpb(_URL_, params).subscribe((data: any) => {

            const auxResponse = data.Response;

            if (auxResponse) {
                if (formulario) {
                    let Opb = {
                        OpbCode: '',
                        Description: ''
                    };
                    Opb = auxResponse[0];
                    this.vehiculoForm.get('Opb').setValue(Opb, { emitEvent: false });
                } else {
                    let arrayOpb = [];
                    let dataOpbMapeados = [];
                    arrayOpb = data.Response;
                    dataOpbMapeados = this.mapearOpb(arrayOpb);
                    this.dataOpb = this.filterOpbPeugeot(query, dataOpbMapeados);
                }

            } else {
                this.dataOpb = [];
            }
        });

    }

    mapearOpb(arrayOpb) {
        const newArrayMarca = [];
        Object.keys(arrayOpb).map(function (key) {
            const itemMarca = {
                Description: arrayOpb[key]['Description'],
                OpbCode: arrayOpb[key]['OPERATIONTYPE']
            };
            newArrayMarca.push(itemMarca);
        });
        return newArrayMarca;
    }

    //busca en todo el string el OPB
    filterOpb(query, arrayOpb: any[]): any[] {
        const filtered: OPB[] = [];
        for (let i = 0; i < arrayOpb.length; i++) {
            const opb = arrayOpb[i];
            if (opb.Description.toLowerCase().indexOf(query.toLowerCase()) >= 0 || opb.OpbCode.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                filtered.push(opb);
            }
        }

        return filtered;
    }

    filterOpbPeugeot(query, arrayOpb: any[]): any[] {
        const filtered: OPB[] = [];
        for (let i = 0; i < arrayOpb.length; i++) {
            const opb = arrayOpb[i];
            if (opb.Description.toLowerCase().indexOf(query.toLowerCase()) >= 0 || opb.OpbCode.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                filtered.push(opb);
            }
        }
        return filtered;
    }

    setSelectedCode(event) {
        this.selectedAccount = event;
        this.vehiculoForm.get('Opb').setValue(event);
        this.vehiculoForm.get('OpbCode').setValue(event.OpbCode);
    }

    isEmpty(name) {
        return this.vehiculoForm.get(name).value === '' || this.vehiculoForm.get(name).value === null;
    }

    onCloseModalESA($event) {
        this.showModalESA = false;
    }

}

